/* eslint-disable */
import React, { useState, ChangeEvent, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  SelectChangeEvent,
  Paper,
  Dialog,
  DialogContent,
  Autocomplete,
  Alert,
  Chip,
  Stack,
  CircularProgress,
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  Settings,
  Business,
  Gavel,
  BarChart,
  SmartToy,
  Security,
  Email,
  Save,
  Close,
  AccountBalanceWallet,
  Rule,
  AssignmentTurnedIn,
  Add,
} from "@mui/icons-material";
import { IUser } from "../Login/ILogin";
import { getSessionUser, hasAdminUser } from "../../utils/users";
import { Container, Content } from "./Style";
import EmbededInstructionsComponent from "./EmbededInstuctions";
import EmbededSuporteComponent from "../Custom/EmbededSuporte";
import { Header } from "../Header";
import { apiOperation, headers } from "../../services/api";
import { Resultado } from "../../models/base/basic";
import { CATALOGO_PARAMETROS } from "./enums";
import { ModalAdicionarParametro } from "./validacaoEnum";
import { Empresas } from "../../utils/empresa";
import {
  TIPOS_GARANTIA_RDP,
  TIPO_PARAMETRO_GARANTIAS,
  PESO_CRITERIO_GARANTIAS_INICIAL,
  COMPOSICOES_GARANTIA_PADRAO_RDP,
  montarChaveCombinacaoGarantia,
  parseChaveCombinacaoGarantia,
  getLabelTipoGarantia,
  getGrupoTipoGarantia,
  isCriterioGarantias,
  validarComposicoesGarantia,
} from "../../constants/garantiasRdp";

// --- ESTILOS MODERNOS ---
const modernCardStyle = {
  p: { xs: 2, sm: 3 },
  borderRadius: 4,
  boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.03)",
  border: "1px solid rgba(0, 0, 0, 0.04)",
  backgroundColor: "#ffffff",
};

const accordionStyle = {
  mb: 1,
  borderRadius: "16px !important",
  boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.04)",
  border: "1px solid rgba(0, 0, 0, 0.05)",
  "&:before": { display: "none" },
  overflow: "hidden",
  transition: "all 0.2s ease-in-out",
};

const tableHeaderStyle = {
  fontWeight: 700,
  color: "text.secondary",
  textTransform: "uppercase" as const,
  fontSize: "0.75rem",
  letterSpacing: "0.5px",
  backgroundColor: "#f8fafc",
};

interface ConfiguracaoExtratorParametro {
  configuracaoExtratorParametroId: string;
  configuracaoExtratorId: string;
  nomeAtributo: string;
  definicaoAtributo: string;
  tipoAtributo: number;
  descricaoAtributo?: string;
  tipoParametro: number;
  obrigatorio: boolean;
  ativo: boolean;
  chave: boolean;
  usuarioEdicao: string;
  dataEdicao: string;
}

interface ConfiguracaoExtrator {
  configuracaoExtratorId: string;
  configuracaoId: string;
  tipoDocumento: number;
  tipoRetorno: number;
  nomeAtributo: string;
  prompt: string;
  ativo: boolean;
  usuarioEdicao: string;
  dataEdicao: string;
  configuracaoExtratorParametro: ConfiguracaoExtratorParametro[];
}

const GUID_VAZIO = "00000000-0000-0000-0000-000000000000";

const criarRowKeyGarantia = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `ui-${Date.now()}-${Math.random()}`;

const criarGarantiaIdsPersistidos = (
  composicoes?: ConfiguracaoGarantiaComposicao[],
) =>
  new Set(
    (composicoes || [])
      .map((c) => c.configuracaoGarantiaComposicaoId)
      .filter((id) => !!id && id !== GUID_VAZIO),
  );

const mapearGarantiaComposicoesDoServidor = (
  composicoes: ConfiguracaoGarantiaComposicao[] | undefined,
  idsPersistidos: Set<string>,
): ConfiguracaoGarantiaComposicao[] =>
  (composicoes || []).map((composicao) => ({
    ...composicao,
    rowKey: idsPersistidos.has(composicao.configuracaoGarantiaComposicaoId)
      ? composicao.configuracaoGarantiaComposicaoId
      : criarRowKeyGarantia(),
  }));

const normalizarGarantiaComposicoesParaSalvar = (
  composicoes: ConfiguracaoGarantiaComposicao[],
  idsPersistidos: Set<string>,
): Omit<ConfiguracaoGarantiaComposicao, "rowKey">[] =>
  composicoes.map(({ rowKey: _rowKey, ...composicao }) => ({
    ...composicao,
    configuracaoGarantiaComposicaoId: idsPersistidos.has(
      composicao.configuracaoGarantiaComposicaoId,
    )
      ? composicao.configuracaoGarantiaComposicaoId
      : GUID_VAZIO,
  }));

interface ConfiguracaoGarantiaComposicao {
  configuracaoGarantiaComposicaoId: string;
  rowKey?: string;
  configuracaoId: string;
  chaveCombinacao: string;
  fator: number;
  ativo: boolean;
  descricao?: string;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
}

interface PromptAzure {
  promptAzureId: string;
  configuracaoId: string;
  tipo: number;
  nome: string;
  promptTexto: string;
  ativo: boolean;
  dataInclusao: string;
  dataEdicao: string;
  usuarioInclusao: string;
}

interface ConfiguracaoIndicadoresEmpresa {
  id: string;
  empresaId: string;
  codigo: number;
  descricao: string;
  secao: string;
  ordemApresentacao: number;
  usuarioInclusao: string;
  dataInclusao: string;
}

interface ConfiguracaoClassificacaoInterna {
  configuracaoClassificacaoInternaId: string;
  configuracaoPorteId: string;
  tipoClassificacao: string;
  de: number;
  ate: number;
  nota: number;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
}

interface ConfiguracaoCriterio {
  configuracaoCriterioId: string;
  configuracaoPorteId: string;
  tipoParametro: string;
  pesoComDocumentacao: number;
  pesoSemDocumentacao: number;
  pesoComDocumentacaoRelacionamentoDefinido: number;
  pesoSemDocumentacaoRelacionamentoDefinido: number;
  indicadorEsperado: number;
  nota: number;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
  tipoPessoa: string;
  tipoCriterio: string;
  ativo: boolean;
  descricao: string;
}

interface ConfiguracaoListaSuja {
  configuracaoListaSujaId: string;
  configuracaoPorteId: string;
  tipoListaSuja: string;
  quantidade: number;
  descricao: string;
  nota: number;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
  tipoPorte: string;
}

interface ConfiguracaoRestritivo {
  configuracaoRestritivoId: string;
  configuracaoPorteId: string;
  descricao: string;
  quantidade: number;
  valor: number;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
  tipoPorte: string;
}

interface ConfiguracaoTempoFundacao {
  configuracaoTempoFundacaoId: string;
  configuracaoPorteId: string;
  tipoClassificacao: string;
  de: number;
  ate: number;
  nota: number;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
}

interface ConfiguracaoCriterioAnaliseSimplificada {
  configuracaoCriterioAnaliseSimplificadaId: string;
  configuracaoPorteId: string;
  tipoParametro: number;
  descricao?: string;
  tipoPessoa?: number;
  peso: number;
  indicadorEsperado: number;
  ativo: boolean;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
}

interface ConfiguracaoPorte {
  configuracaoPorteId: string;
  configuracaoId: string;
  tipoPorte: string;
  descricao: string;
  de: number;
  ate: number;
  capitalSocialDe: number;
  capitalSocialAte: number;
  limiteMaximo: number;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
  configuracao: string;
  configuracaoClassificacaoInterna: ConfiguracaoClassificacaoInterna[];
  configuracaoCriterio: ConfiguracaoCriterio[];
  configuracaoListaSuja: ConfiguracaoListaSuja[];
  configuracaoRestritivo: ConfiguracaoRestritivo[];
  configuracaoTempoFundacao: ConfiguracaoTempoFundacao[];
  configuracaoCriterioAnaliseSimplificada: ConfiguracaoCriterioAnaliseSimplificada[];
}

interface Empresa {
  empresaId: string;
  razao: string;
  nomeFantasia: string;
  cnpjOuCpf: string;
  ativo: boolean;
  endereco: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  email: string;
  situacao: string;
  naturezaJuridica: string;
  dataFundacao: string;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
}

interface ConfiguracaoEmailBrt {
  configuracaoEmailBrtId: string;
  configuracaoId: string;
  ativo: boolean;
  destinatarios: string;
  assunto: string;
  copia: string;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
}

interface ConfiguracaoCompleta {
  configuracaoId: string;
  empresaId: string;
  recusaEmpresaNaoAtivaNaReceita: boolean;
  recusaEmpresaRecuperacaoJudicial: boolean;
  recusaEmpresaComFundacaoMenorQueTempoMinimo: boolean;
  tempoMinimoFundacao: number;
  recusaEmpresaBaixadaNoSintegra: boolean;
  recusaEmpresaComApontamentoNoCeis: boolean;
  recusaEmpresaComApontamentoNoCnep: boolean;
  utilizaPoliticaNova: boolean;
  tipoMotorCalculo: number;
  descricaoTipoMotorCalculo?: string;
  opcoesMotorCalculo?: Record<number, string>;
  limitarLimiteSugeridoPorValorSolicitado: boolean;
  possuiBureauSpc: boolean;
  possuiBureauSerasa: boolean;
  possuiBureauBoaVista: boolean;
  calcularNotaPorte: boolean;
  calcularMediaScore: boolean;
  calcularMediaReceitaLiquida: boolean;
  calcularNotaProporcionalDefault: boolean;
  dataInclusao: string;
  usuarioInclusao: string;
  dataEdicao: string;
  usuarioEdicao: string;
  empresa: Empresa;
  configuracaoPorte: ConfiguracaoPorte[];
  configuracaoExtrator: ConfiguracaoExtrator[];
  promptAzure: PromptAzure[];
  configuracaoGarantiaComposicao: ConfiguracaoGarantiaComposicao[];
  configuracaoEmailBrt?: ConfiguracaoEmailBrt;
  configuracaoIndicadoresEmpresa?: ConfiguracaoIndicadoresEmpresa[];
}

interface OpcaoEmpresa {
  empresaId: string;
  label: string;
}

const estadoInicialEmpresa: Empresa = {
  empresaId: "",
  razao: "",
  nomeFantasia: "",
  cnpjOuCpf: "",
  ativo: true,
  endereco: "",
  bairro: "",
  cidade: "",
  estado: "",
  cep: "",
  email: "",
  situacao: "",
  naturezaJuridica: "",
  dataFundacao: "",
  dataInclusao: "",
  usuarioInclusao: "",
  dataEdicao: "",
  usuarioEdicao: "",
};

const configuracaoInicial: ConfiguracaoCompleta = {
  configuracaoId: "",
  empresaId: "",
  recusaEmpresaNaoAtivaNaReceita: true,
  recusaEmpresaRecuperacaoJudicial: true,
  recusaEmpresaComFundacaoMenorQueTempoMinimo: true,
  tempoMinimoFundacao: 0,
  recusaEmpresaBaixadaNoSintegra: true,
  recusaEmpresaComApontamentoNoCeis: true,
  recusaEmpresaComApontamentoNoCnep: true,
  utilizaPoliticaNova: false,
  limitarLimiteSugeridoPorValorSolicitado: false,
  possuiBureauSpc: false,
  possuiBureauSerasa: false,
  possuiBureauBoaVista: false,
  calcularNotaPorte: false,
  calcularMediaScore: false,
  calcularMediaReceitaLiquida: false,
  calcularNotaProporcionalDefault: false,
  tipoMotorCalculo: 0,
  descricaoTipoMotorCalculo: "",
  opcoesMotorCalculo: {},
  dataInclusao: "",
  usuarioInclusao: "",
  dataEdicao: "",
  usuarioEdicao: "",
  empresa: estadoInicialEmpresa,
  configuracaoPorte: [],
  configuracaoExtrator: [],
  promptAzure: [],
  configuracaoGarantiaComposicao: [],
  configuracaoEmailBrt: undefined,
  configuracaoIndicadoresEmpresa: [],
};

let globalUser: IUser | null = null;

export const ConfiguracoesForm = () => {
  const [erroIntervalo, setErroIntervalo] = useState({
    erro: false,
    index: -1,
  });

  const [errosGarantias, setErrosGarantias] = useState<string[]>([]);
  const [configuracaoCompleta, setConfiguracaoCompleta] =
    useState<ConfiguracaoCompleta>(configuracaoInicial);
  const [, setShowLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [porteSelecionadoIndex, setPorteSelecionadoIndex] = useState<number>(0);

  const [empresaSelecionada, setEmpresaSelecionada] =
    useState<OpcaoEmpresa | null>(null);
  const [garantiaIdsPersistidos, setGarantiaIdsPersistidos] = useState<
    Set<string>
  >(() => new Set());

  const isGarantiaPersistida = (id?: string) =>
    !!id && id !== GUID_VAZIO && garantiaIdsPersistidos.has(id);

  const rowKeyGarantia = (composicao: ConfiguracaoGarantiaComposicao) =>
    composicao.rowKey ||
    (isGarantiaPersistida(composicao.configuracaoGarantiaComposicaoId)
      ? composicao.configuracaoGarantiaComposicaoId
      : criarRowKeyGarantia());

  const [listaEmpresas, setListaEmpresas] = useState<OpcaoEmpresa[]>([]);
  const [paginaEmpresas, setPaginaEmpresas] = useState(1);
  const [carregandoEmpresas, setCarregandoEmpresas] = useState(false);
  const [temMaisEmpresas, setTemMaisEmpresas] = useState(true);

  useEffect(() => {
    const admin = hasAdminUser();
    setIsAdmin(admin);

    if (!admin) {
      buscarConfiguracoesCompletas();
    }
  }, []);

  const [userLogged, setUserLogged] = useState<boolean>(false);

  useEffect(() => {
    globalUser = getSessionUser();
    if (globalUser) setUserLogged(true);
  }, []);

  const isEmpresaBrt =
    empresaSelecionada?.empresaId === Empresas.BRT ||
    configuracaoCompleta.empresaId === Empresas.BRT;

  const buscarConfiguracoesCompletas = async (idEmpresaOverride?: string) => {
    setShowLoading(true);
    try {
      const config = { headers: headers() };

      let url = `configuracao/obter/configuracoes`;
      if (idEmpresaOverride) {
        url += `?empresaId=${idEmpresaOverride}`;
      }

      const { data } = await apiOperation.get<ConfiguracaoCompleta>(
        url,
        config,
      );

      if (data) {
        const idsPersistidos = criarGarantiaIdsPersistidos(
          data.configuracaoGarantiaComposicao,
        );
        setGarantiaIdsPersistidos(idsPersistidos);
        setConfiguracaoCompleta({
          ...data,
          configuracaoGarantiaComposicao: mapearGarantiaComposicoesDoServidor(
            data.configuracaoGarantiaComposicao,
            idsPersistidos,
          ),
        });
      } else {
        setConfiguracaoCompleta(configuracaoInicial);
        alert("Nenhuma configuração encontrada para a empresa selecionada.");
      }
    } catch (error: any) {
      console.error("Erro ao buscar as configurações:", error);
    } finally {
      setShowLoading(false);
    }
  };

  const handleEmpresaChange = (event: any, newValue: OpcaoEmpresa | null) => {
    setEmpresaSelecionada(newValue);
    if (newValue && newValue.empresaId) {
      buscarConfiguracoesCompletas(newValue.empresaId);
    } else {
      setConfiguracaoCompleta(configuracaoInicial);
    }
  };

  const [modalParametroOpen, setModalParametroOpen] = useState(false);
  const [extratorAlvoId, setExtratorAlvoId] = useState<string | null>(null);

  const handleOpenModalParametro = (extratorId: string) => {
    setExtratorAlvoId(extratorId);
    setModalParametroOpen(true);
  };

  const handleCloseModalParametro = () => {
    setModalParametroOpen(false);
    setExtratorAlvoId(null);
  };

  const handleSalvarParametroDoModal = (novoItem: any) => {
    if (!extratorAlvoId) return;

    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prev) => {
      const newConfig = { ...prev };
      const index = newConfig.configuracaoExtrator.findIndex(
        (e) => e.configuracaoExtratorId === extratorAlvoId,
      );

      if (index !== -1) {
        const novoParametroCompleto: ConfiguracaoExtratorParametro = {
          configuracaoExtratorParametroId: generateTempId(),
          configuracaoExtratorId: extratorAlvoId,
          nomeAtributo: novoItem.NomeAtributo,
          definicaoAtributo: novoItem.DefinicaoAtributo || "",
          tipoParametro: novoItem.TipoParametro,
          tipoAtributo: 1,
          descricaoAtributo: "",
          obrigatorio: false,
          ativo: true,
          chave: false,
          usuarioEdicao: user,
          dataEdicao: dataAtual,
        };

        const extratorAtualizado = {
          ...newConfig.configuracaoExtrator[index],
          configuracaoExtratorParametro: [
            novoParametroCompleto,
            ...(newConfig.configuracaoExtrator[index]
              .configuracaoExtratorParametro || []),
          ],
        };

        newConfig.configuracaoExtrator[index] = extratorAtualizado;
      }
      return newConfig;
    });
    handleCloseModalParametro();
  };

  const getParametrosAtuaisDoExtratorAlvo = () => {
    if (!extratorAlvoId) return [];
    const extrator = configuracaoCompleta.configuracaoExtrator.find(
      (e) => e.configuracaoExtratorId === extratorAlvoId,
    );
    return (extrator?.configuracaoExtratorParametro || []).map((p) => ({
      TipoParametro: p.tipoParametro,
      NomeAtributo: p.nomeAtributo,
    }));
  };

  const isEmpresaRdp =
    empresaSelecionada?.empresaId === Empresas.Rdp ||
    configuracaoCompleta.empresaId === Empresas.Rdp;

  const criterioVisivelGradePesos = (criterio: ConfiguracaoCriterio) =>
    criterio.ativo &&
    !!criterio.descricao &&
    String(criterio.tipoParametro) !== "40" &&
    (isEmpresaRdp || !isCriterioGarantias(criterio.tipoParametro));

  const porteTemCriterioGarantias = (porteIndex: number) => {
    const porte = configuracaoCompleta.configuracaoPorte[porteIndex];
    if (!porte) return false;
    return (porte.configuracaoCriterio || []).some(
      (c) => c.ativo && isCriterioGarantias(c.tipoParametro),
    );
  };

  const algumPorteSemCriterioGarantias =
    configuracaoCompleta.configuracaoPorte.some(
      (_, index) => !porteTemCriterioGarantias(index),
    );

  const incluirCriterioGarantiasEmPortes = (
    portes: ConfiguracaoPorte[],
    user: string,
    dataAtual: string,
  ): ConfiguracaoPorte[] =>
    portes.map((porte) => {
      const jaTemGarantias = (porte.configuracaoCriterio || []).some(
        (c) => c.ativo && isCriterioGarantias(c.tipoParametro),
      );
      if (jaTemGarantias) return porte;

      return {
        ...porte,
        configuracaoCriterio: [
          ...(porte.configuracaoCriterio || []),
          {
            configuracaoCriterioId: generateTempId(),
            configuracaoPorteId: porte.configuracaoPorteId,
            descricao: "Garantias",
            tipoParametro: String(TIPO_PARAMETRO_GARANTIAS),
            ...PESO_CRITERIO_GARANTIAS_INICIAL,
            nota: 0,
            ativo: true,
            tipoCriterio: "1",
            tipoPessoa: "1",
            dataInclusao: dataAtual,
            usuarioInclusao: user,
            dataEdicao: dataAtual,
            usuarioEdicao: user,
          },
        ],
      };
    });

  const handleIncluirCriterioGarantiasTodosPortes = () => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prev) => ({
      ...prev,
      configuracaoPorte: incluirCriterioGarantiasEmPortes(
        prev.configuracaoPorte,
        user,
        dataAtual,
      ),
      usuarioEdicao: user,
      dataEdicao: dataAtual,
    }));
  };

  const handleAddGarantiaComposicao = () => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prev) => ({
      ...prev,
      configuracaoGarantiaComposicao: [
        ...(prev.configuracaoGarantiaComposicao || []),
        {
          configuracaoGarantiaComposicaoId: GUID_VAZIO,
          rowKey: criarRowKeyGarantia(),
          configuracaoId: prev.configuracaoId,
          chaveCombinacao: "",
          fator: 0,
          ativo: true,
          descricao: "",
          dataInclusao: dataAtual,
          usuarioInclusao: user,
          dataEdicao: dataAtual,
          usuarioEdicao: user,
        },
      ],
    }));
  };

  const handleGarantiaComposicaoChange = (
    composicaoRowKey: string,
    field: keyof ConfiguracaoGarantiaComposicao | "tipos",
    value: string | number | boolean | string[],
  ) => {
    setConfiguracaoCompleta((prev) => ({
      ...prev,
      configuracaoGarantiaComposicao: (
        prev.configuracaoGarantiaComposicao || []
      ).map((item) => {
        if (rowKeyGarantia(item) !== composicaoRowKey) return item;
        if (field === "tipos" && Array.isArray(value)) {
          return {
            ...item,
            chaveCombinacao: montarChaveCombinacaoGarantia(value as string[]),
          };
        }
        return { ...item, [field]: value };
      }),
    }));
  };

  const handleRemoveGarantiaComposicao = (composicaoRowKey: string) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();
    setConfiguracaoCompleta((prev) => ({
      ...prev,
      configuracaoGarantiaComposicao: (
        prev.configuracaoGarantiaComposicao || []
      ).map((item) => {
        if (rowKeyGarantia(item) !== composicaoRowKey) return item;
        return {
          ...item,
          ativo: false,
          usuarioEdicao: user,
          dataEdicao: dataAtual,
        };
      }),
    }));
  };

  const handleTipoMotorChange = (event: SelectChangeEvent<number>) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prev) => ({
      ...prev,
      tipoMotorCalculo: Number(event.target.value),
      usuarioEdicao: user,
      dataEdicao: dataAtual,
    }));
  };

  const handleAddPromptAzure = () => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();
    const tempId = generateTempId();

    const novoPrompt: PromptAzure = {
      promptAzureId: tempId,
      configuracaoId: configuracaoCompleta.configuracaoId,
      tipo: 0,
      nome: "Parecer Completo",
      promptTexto: "",
      ativo: true,
      dataInclusao: dataAtual,
      usuarioInclusao: user,
      dataEdicao: dataAtual,
    };

    setConfiguracaoCompleta((prev) => ({
      ...prev,
      promptAzure: [novoPrompt, ...(prev.promptAzure || [])],
    }));
  };

  const handlePromptAzureChange = (
    promptId: string,
    field: keyof PromptAzure,
    value: any,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      const prompts = newConfig.promptAzure || [];

      newConfig.promptAzure = prompts.map((prompt) => {
        if (prompt.promptAzureId === promptId) {
          return {
            ...prompt,
            [field]: value,
            dataEdicao: dataAtual,
          };
        }
        return prompt;
      });

      newConfig.usuarioEdicao = user;
      newConfig.dataEdicao = dataAtual;

      return newConfig;
    });
  };

  const handleExtratorChange = (
    extratorId: string,
    field: keyof ConfiguracaoExtrator,
    value: any,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };

      newConfig.configuracaoExtrator = newConfig.configuracaoExtrator.map(
        (extrator) => {
          if (extrator.configuracaoExtratorId === extratorId) {
            const updatedExtrator = {
              ...extrator,
              [field]: value,
              usuarioEdicao: user,
              dataEdicao: dataAtual,
            };

            if (field === "tipoDocumento") {
              if (Number(value) === 1)
                updatedExtrator.nomeAtributo = "Balanço Patrimonial / DRE";
              else if (Number(value) === 2) updatedExtrator.nomeAtributo = "";
            }

            return updatedExtrator;
          }
          return extrator;
        },
      );

      newConfig.usuarioEdicao = user;
      newConfig.dataEdicao = dataAtual;

      return newConfig;
    });
  };

  const handleExtratorParametroChange = (
    extratorId: string,
    parametroId: string,
    field: keyof ConfiguracaoExtratorParametro,
    value: any,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      const extratorIndex = newConfig.configuracaoExtrator.findIndex(
        (e) => e.configuracaoExtratorId === extratorId,
      );

      if (extratorIndex !== -1) {
        const extrator = { ...newConfig.configuracaoExtrator[extratorIndex] };
        extrator.configuracaoExtratorParametro =
          extrator.configuracaoExtratorParametro.map((param) => {
            if (field === "chave" && value === true) {
              if (param.configuracaoExtratorParametroId === parametroId) {
                return {
                  ...param,
                  [field]: value,
                  usuarioEdicao: user,
                  dataEdicao: dataAtual,
                };
              }
              if (param.chave) {
                return {
                  ...param,
                  chave: false,
                  usuarioEdicao: user,
                  dataEdicao: dataAtual,
                };
              }
              return param;
            }

            if (param.configuracaoExtratorParametroId === parametroId) {
              return {
                ...param,
                [field]: value,
                usuarioEdicao: user,
                dataEdicao: dataAtual,
              };
            }
            return param;
          });

        extrator.usuarioEdicao = user;
        extrator.dataEdicao = dataAtual;
        newConfig.configuracaoExtrator[extratorIndex] = extrator;
      }

      newConfig.usuarioEdicao = user;
      newConfig.dataEdicao = dataAtual;

      return newConfig;
    });
  };

  const generateTempId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  };

  const handleCarregarComposicoesPadraoRdp = () => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();
    const existentes = new Set(
      (configuracaoCompleta.configuracaoGarantiaComposicao || []).map(
        (c) => c.chaveCombinacao,
      ),
    );

    const novas = COMPOSICOES_GARANTIA_PADRAO_RDP.filter(
      (padrao) =>
        !existentes.has(montarChaveCombinacaoGarantia(padrao.codigos)),
    ).map((padrao) => ({
      configuracaoGarantiaComposicaoId: GUID_VAZIO,
      rowKey: criarRowKeyGarantia(),
      configuracaoId: configuracaoCompleta.configuracaoId,
      chaveCombinacao: montarChaveCombinacaoGarantia(padrao.codigos),
      fator: padrao.fator,
      ativo: true,
      descricao: padrao.descricao,
      dataInclusao: dataAtual,
      usuarioInclusao: user,
      dataEdicao: dataAtual,
      usuarioEdicao: user,
    }));

    if (novas.length === 0) {
      alert("As combinações padrão já estão cadastradas.");
      return;
    }

    setConfiguracaoCompleta((prev) => ({
      ...prev,
      configuracaoPorte: incluirCriterioGarantiasEmPortes(
        prev.configuracaoPorte,
        user,
        dataAtual,
      ),
      configuracaoGarantiaComposicao: [
        ...(prev.configuracaoGarantiaComposicao || []),
        ...novas,
      ],
      usuarioEdicao: user,
      dataEdicao: dataAtual,
    }));
    setErrosGarantias([]);
  };

  const handleAddExtrator = () => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();
    const tempId = generateTempId();

    const novoExtrator: ConfiguracaoExtrator = {
      configuracaoExtratorId: tempId,
      configuracaoId: configuracaoCompleta.configuracaoId,
      tipoDocumento: 1,
      tipoRetorno: 1,
      nomeAtributo: "Novo Extrator",
      prompt: "",
      ativo: true,
      usuarioEdicao: user,
      dataEdicao: dataAtual,
      configuracaoExtratorParametro: [],
    };

    setConfiguracaoCompleta((prev) => ({
      ...prev,
      configuracaoExtrator: [novoExtrator, ...prev.configuracaoExtrator],
    }));
  };

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      (newConfig as any)[name] = checked;
      return newConfig;
    });
  };

  const handleInputChange = (
    event: ChangeEvent<HTMLInputElement>,
    index?: number,
  ) => {
    const { name, value } = event.target;
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prevConfig) => ({
      ...prevConfig,
      [name]:
        name.includes("valor") || name.includes("tempoMinimo")
          ? Number(value)
          : value,
      usuarioEdicao: user,
      dataEdicao: dataAtual,
    }));
  };

  const handleIndicadoresChange = (
    criterioIdDoClick: string,
    field: keyof ConfiguracaoCriterio,
    value: any,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prevConfig) => {
      let tipoParametroAlvo: number | null = null;
      let descricaoAlvo = "";

      for (const porte of prevConfig.configuracaoPorte) {
        const found = porte.configuracaoCriterio.find(
          (c) => c.configuracaoCriterioId === criterioIdDoClick,
        );
        if (found) {
          tipoParametroAlvo = Number(found.tipoParametro);
          descricaoAlvo = found.descricao || "";
          break;
        }
      }

      if (tipoParametroAlvo === null && !descricaoAlvo) return prevConfig;

      const novosPortes = prevConfig.configuracaoPorte.map((porte) => {
        const novosCriterios = porte.configuracaoCriterio.map((criterio) => {
          const ehOMesmoIndicador =
            (tipoParametroAlvo !== null &&
              Number(criterio.tipoParametro) === tipoParametroAlvo) ||
            (descricaoAlvo !== "" &&
              criterio.descricao?.trim() === descricaoAlvo.trim());

          if (ehOMesmoIndicador) {
            return {
              ...criterio,
              [field]: value,
              usuarioEdicao: user,
              dataEdicao: dataAtual,
            };
          }
          return criterio;
        });

        return { ...porte, configuracaoCriterio: novosCriterios };
      });

      return {
        ...prevConfig,
        configuracaoPorte: novosPortes,
        usuarioEdicao: user,
        dataEdicao: dataAtual,
      };
    });
  };

  const handleCriterioChange = (
    porteIndex: number,
    field:
      | "pesoComDocumentacao"
      | "pesoSemDocumentacao"
      | "pesoComDocumentacaoRelacionamentoDefinido"
      | "pesoSemDocumentacaoRelacionamentoDefinido"
      | "indicadorEsperado",
    value: any,
    descricaoAlvo: string,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    let valorFinal: string | number = value;
    if (field === "indicadorEsperado") {
      valorFinal = value.toString().replace(/\D/g, "");
    } else {
      valorFinal = value === "" || value === null ? 0 : Number(value);
      if (Number.isNaN(valorFinal as number)) valorFinal = 0;
    }

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      const porteAtual = newConfig.configuracaoPorte[porteIndex];

      const novosCriterios = porteAtual.configuracaoCriterio.map((criterio) => {
        const mesmoCriterio =
          criterio.descricao === descricaoAlvo ||
          (descricaoAlvo === "Garantias" &&
            isCriterioGarantias(criterio.tipoParametro));
        return mesmoCriterio
          ? {
              ...criterio,
              [field]: valorFinal,
              usuarioEdicao: user,
              dataEdicao: dataAtual,
            }
          : criterio;
      });

      newConfig.configuracaoPorte[porteIndex] = {
        ...porteAtual,
        configuracaoCriterio: novosCriterios,
      };

      return newConfig;
    });
  };

  const handleValueChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    descricao?: string,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();
    const { value } = event.target;
    const valorProcessado = value === "" ? "" : value;

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = {
        ...prevConfig,
        usuarioEdicao: user,
        dataEdicao: dataAtual,
      };

      newConfig.configuracaoPorte = newConfig.configuracaoPorte.map((porte) => {
        const updatedCriterio = porte.configuracaoCriterio.map((indicador) =>
          indicador.descricao === descricao
            ? {
                ...indicador,
                indicadorEsperado: Number(valorProcessado),
                usuarioEdicao: user,
                dataEdicao: dataAtual,
              }
            : indicador,
        );

        return { ...porte, configuracaoCriterio: updatedCriterio };
      });

      return newConfig;
    });
  };

  const handleRefinChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    descricao: string = "RestritivosRefin",
    porteIndex?: number,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();
    const { value } = event.target;

    if (porteIndex === undefined) return;
    const valorProcessado = value === "" ? 0 : Number(value);

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      const porte = { ...newConfig.configuracaoPorte[porteIndex] };

      porte.configuracaoCriterio = porte.configuracaoCriterio.map(
        (criterio) => {
          if (Number(criterio.tipoParametro) === 219) {
            return {
              ...criterio,
              indicadorEsperado: valorProcessado,
              usuarioEdicao: user,
              dataEdicao: dataAtual,
            };
          }
          return criterio;
        },
      );

      const possuiCriterio = porte.configuracaoCriterio.some(
        (c) => c.descricao === descricao || Number(c.tipoParametro) === 219,
      );

      if (!possuiCriterio) {
        porte.configuracaoCriterio.push({
          configuracaoCriterioId: generateTempId(),
          configuracaoPorteId: porte.configuracaoPorteId,
          descricao: descricao,
          tipoParametro: "219",
          indicadorEsperado: valorProcessado,
          pesoComDocumentacao: 0,
          pesoSemDocumentacao: 0,
          pesoComDocumentacaoRelacionamentoDefinido: 0,
          pesoSemDocumentacaoRelacionamentoDefinido: 0,
          nota: 0,
          ativo: true,
          dataInclusao: dataAtual,
          usuarioInclusao: user,
          dataEdicao: dataAtual,
          usuarioEdicao: user,
        } as any);
      }

      newConfig.configuracaoPorte[porteIndex] = porte;
      newConfig.usuarioEdicao = user;
      newConfig.dataEdicao = dataAtual;
      return newConfig;
    });
  };

  const handleListaSujaChange = (
    porteIndex: number,
    listaSujaIndex: number,
    field: keyof ConfiguracaoListaSuja,
    value: any,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      const porte = { ...newConfig.configuracaoPorte[porteIndex] };
      const listaSuja = {
        ...porte.configuracaoListaSuja[listaSujaIndex],
        [field]: value,
        usuarioEdicao: user,
        dataEdicao: dataAtual,
      };

      porte.configuracaoListaSuja[listaSujaIndex] = listaSuja;
      newConfig.configuracaoPorte[porteIndex] = porte;
      return newConfig;
    });
  };

  const handleRestritivoChange = (
    porteIndex: number,
    restritivoIndex: number,
    field: keyof ConfiguracaoRestritivo,
    value: any,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();
    let cleanedValue = value;

    if (field === "valor") {
      cleanedValue = value.replace(/\D/g, "");
    }

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      const porte = { ...newConfig.configuracaoPorte[porteIndex] };
      const restritivo = {
        ...porte.configuracaoRestritivo[restritivoIndex],
        [field]: cleanedValue,
        usuarioEdicao: user,
        dataEdicao: dataAtual,
      };

      porte.configuracaoRestritivo[restritivoIndex] = restritivo;
      newConfig.configuracaoPorte[porteIndex] = porte;
      return newConfig;
    });
  };

  // --- HANDLERS DA ANÁLISE SIMPLIFICADA ---
  const handleAddCriterioAnaliseSimplificada = () => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prev) => {
      const newConfig = { ...prev };
      const portes = [...newConfig.configuracaoPorte];
      const porte = { ...portes[porteSelecionadoIndex] };

      const criterios = [
        ...(porte.configuracaoCriterioAnaliseSimplificada || []),
      ];

      criterios.push({
        configuracaoCriterioAnaliseSimplificadaId: generateTempId(),
        configuracaoPorteId: porte.configuracaoPorteId,
        tipoParametro: 0,
        descricao: "",
        peso: 0,
        indicadorEsperado: 0,
        ativo: true,
        tipoPessoa: 1,
        dataInclusao: dataAtual,
        usuarioInclusao: user,
        dataEdicao: dataAtual,
        usuarioEdicao: user,
      });

      porte.configuracaoCriterioAnaliseSimplificada = criterios;
      portes[porteSelecionadoIndex] = porte;
      newConfig.configuracaoPorte = portes;

      return newConfig;
    });
  };

  const handleChangeCriterioAnaliseSimplificada = (
    indexCriterio: number,
    field: keyof ConfiguracaoCriterioAnaliseSimplificada,
    value: any,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prev) => {
      const newConfig = { ...prev };
      const portes = [...newConfig.configuracaoPorte];
      const porte = { ...portes[porteSelecionadoIndex] };
      const criterios = [
        ...(porte.configuracaoCriterioAnaliseSimplificada || []),
      ];

      const item = { ...criterios[indexCriterio] };

      if (field === "tipoParametro") {
        item.tipoParametro = Number(value);
        const opcaoCatalogo = CATALOGO_PARAMETROS.find(
          (p) => p.id === Number(value),
        );
        item.descricao = opcaoCatalogo ? opcaoCatalogo.label : "";
      } else if (field === "ativo") {
        item.ativo = value;
      } else {
        (item as any)[field] = value === "" ? 0 : Number(value);
      }

      item.usuarioEdicao = user;
      item.dataEdicao = dataAtual;

      criterios[indexCriterio] = item;
      porte.configuracaoCriterioAnaliseSimplificada = criterios;
      portes[porteSelecionadoIndex] = porte;
      newConfig.configuracaoPorte = portes;

      return newConfig;
    });
  };

  const handleRemoveCriterioAnaliseSimplificada = (indexCriterio: number) => {
    setConfiguracaoCompleta((prev) => {
      const newConfig = { ...prev };
      const portes = [...newConfig.configuracaoPorte];
      const porte = { ...portes[porteSelecionadoIndex] };
      const criterios = [
        ...(porte.configuracaoCriterioAnaliseSimplificada || []),
      ];

      criterios.splice(indexCriterio, 1);

      porte.configuracaoCriterioAnaliseSimplificada = criterios;
      portes[porteSelecionadoIndex] = porte;
      newConfig.configuracaoPorte = portes;

      return newConfig;
    });
  };

  // --- VALIDAÇÃO ---
  const validarSomaAnaliseSimplificada = () => {
    for (const porte of configuracaoCompleta.configuracaoPorte) {
      const criterios = porte.configuracaoCriterioAnaliseSimplificada || [];
      const ativos = criterios.filter((c) => c.ativo);

      if (ativos.length > 0) {
        const somaJuridica = ativos
          .filter(
            (c) =>
              Number(c.tipoPessoa) === 1 ||
              c.tipoPessoa === undefined ||
              c.tipoPessoa === null,
          )
          .reduce((acc, curr) => acc + Number(curr.peso || 0), 0);

        const temJuridica = ativos.some(
          (c) =>
            Number(c.tipoPessoa) === 1 ||
            c.tipoPessoa === undefined ||
            c.tipoPessoa === null,
        );

        // A pré-análise é parametrizada somente para pessoa jurídica.
        if (temJuridica && somaJuridica !== 100) return false;
      }
    }
    return true;
  };

  const calcularTotalColuna = (
    campo:
      | "pesoComDocumentacao"
      | "pesoSemDocumentacao"
      | "pesoComDocumentacaoRelacionamentoDefinido"
      | "pesoSemDocumentacaoRelacionamentoDefinido",
  ) => {
    let total = 0;
    const porteSelecionado =
      configuracaoCompleta.configuracaoPorte[porteSelecionadoIndex];

    if (porteSelecionado) {
      porteSelecionado.configuracaoCriterio
        .filter((criterio) => criterio && criterioVisivelGradePesos(criterio))
        .filter(
          (criterio, index, self) =>
            index === self.findIndex((t) => t.descricao === criterio.descricao),
        )
        .forEach((atual) => {
          if (atual && atual.ativo) {
            const valor = Number(atual[campo]) || 0;
            total += valor;
          }
        });
    }
    return total;
  };

  const validarSomaTotal = () => {
    const totalComBalanco = calcularTotalColuna("pesoComDocumentacao");
    const totalSemBalanco = calcularTotalColuna("pesoSemDocumentacao");
    return totalComBalanco === 100 && totalSemBalanco === 100;
  };

  const handleClassificacaoInternaChange = (
    porteIndex: number,
    tipoClassificacao: number,
    field: "de" | "ate" | "nota",
    value: number,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      const porte = { ...newConfig.configuracaoPorte[porteIndex] };

      const novaClassificacaoInterna = (
        porte.configuracaoClassificacaoInterna || []
      ).map((c) => {
        if (Number(c.tipoClassificacao) === tipoClassificacao) {
          return {
            ...c,
            [field]: value,
            usuarioEdicao: user,
            dataEdicao: dataAtual,
          };
        }
        return c;
      });

      const existeTipo = novaClassificacaoInterna.some(
        (c) => Number(c.tipoClassificacao) === tipoClassificacao,
      );

      if (!existeTipo) {
        novaClassificacaoInterna.push({
          configuracaoClassificacaoInternaId: generateTempId(),
          configuracaoPorteId: porte.configuracaoPorteId,
          tipoClassificacao: String(tipoClassificacao),
          de: field === "de" ? value : 0,
          ate: field === "ate" ? value : 0,
          nota: field === "nota" ? value : 0,
          dataInclusao: dataAtual,
          usuarioInclusao: user,
          dataEdicao: dataAtual,
          usuarioEdicao: user,
        } as any);
      }

      porte.configuracaoClassificacaoInterna = novaClassificacaoInterna;
      newConfig.configuracaoPorte[porteIndex] = porte;
      newConfig.usuarioEdicao = user;
      newConfig.dataEdicao = dataAtual;

      return newConfig;
    });
  };

  const handlePorteChange = (
    porteIndex: number,
    field: keyof ConfiguracaoPorte,
    value: any,
  ) => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prevConfig) => {
      const newConfig = { ...prevConfig };
      const processedValue = value === "" ? 0 : Number(value);

      const porteAtualizado = {
        ...newConfig.configuracaoPorte[porteIndex],
        [field]: processedValue,
        usuarioEdicao: user,
        dataEdicao: dataAtual,
      };

      newConfig.configuracaoPorte[porteIndex] = porteAtualizado;

      const resultado = validarIntervalos(newConfig.configuracaoPorte);
      setErroIntervalo({ erro: resultado.erro, index: resultado.index });

      return newConfig;
    });
  };

  const cancelarAlteracoes = () => {
    window.location.reload();
  };

  const salvarConfiguracoes = async () => {
    if (!validarSomaTotal()) {
      alert(
        "A soma dos pesos dos indicadores deve ser exatamente 100% em cada coluna do porte selecionado.",
      );
      return;
    }

    if (!validarSomaAnaliseSimplificada()) {
      alert(
        "A soma dos pesos dos critérios da pré-análise deve ser exatamente 100% no porte selecionado.",
      );
      return;
    }

    if (isEmpresaRdp) {
      const { valido, erros } = validarComposicoesGarantia(
        configuracaoCompleta.configuracaoGarantiaComposicao || [],
      );
      if (!valido) {
        setErrosGarantias(erros);
        alert(erros.join("\n"));
        return;
      }
      setErrosGarantias([]);
    }

    setShowLoading(true);
    try {
      const config = { headers: headers() };

      const payload = {
        ...configuracaoCompleta,
        empresa: {
          ...configuracaoCompleta.empresa,
          dataFundacao:
            configuracaoCompleta.empresa.dataFundacao === ""
              ? null
              : configuracaoCompleta.empresa.dataFundacao,
        },
        configuracaoGarantiaComposicao: normalizarGarantiaComposicoesParaSalvar(
          configuracaoCompleta.configuracaoGarantiaComposicao || [],
          garantiaIdsPersistidos,
        ),
      };

      const { data } = await apiOperation.post<Resultado<ConfiguracaoCompleta>>(
        `/configuracao/salvar`,
        payload,
        config,
      );

      if (data && !data.erro && data.valor) {
        const empresaIdParaRecarregar =
          configuracaoCompleta.empresaId ||
          (empresaSelecionada ? empresaSelecionada.empresaId : "");
        await buscarConfiguracoesCompletas(empresaIdParaRecarregar);
        alert("Configurações salvas com sucesso!");
      } else {
        const mensagemErro =
          data?.erros?.join("\n") ||
          "Salvo, mas houve um problema no retorno dos dados.";
        alert(mensagemErro);
      }
    } catch (error: any) {
      console.error("Erro ao salvar configurações:", error);
      const mensagemErro =
        error?.response?.data?.erros?.join("\n") ||
        error?.response?.data?.mensagem ||
        error?.message ||
        "Erro ao salvar configurações!";
      alert(mensagemErro);
    } finally {
      setShowLoading(false);
    }
  };

  const validarIntervalos = (
    configuracaoPortes: ConfiguracaoPorte[],
  ): { erro: boolean; index: number } => {
    const ativos = configuracaoPortes
      .map((p, i) => ({ ...p, originalIndex: i }))
      .filter(
        (p) =>
          Number(p.de) > 0 ||
          Number(p.ate) > 0 ||
          Number(p.capitalSocialDe) > 0 ||
          Number(p.capitalSocialAte) > 0,
      );

    if (ativos.length < 2) return { erro: false, index: -1 };

    const sorted = [...ativos].sort(
      (a, b) => Number(a.de || 0) - Number(b.de || 0),
    );

    for (let i = 0; i < sorted.length; i++) {
      const p = sorted[i];
      const de = Number(p.de || 0);
      const ate = Number(p.ate || 0);
      const capDe = Number(p.capitalSocialDe || 0);
      const capAte = Number(p.capitalSocialAte || 0);

      if ((ate > 0 && de >= ate) || (capAte > 0 && capDe >= capAte)) {
        return { erro: true, index: p.originalIndex };
      }

      if (i < sorted.length - 1) {
        const next = sorted[i + 1];
        const nextDe = Number(next.de || 0);
        const nextCapDe = Number(next.capitalSocialDe || 0);

        if (ate > 0 && nextDe > 0 && ate >= nextDe)
          return { erro: true, index: p.originalIndex };
        if (capAte > 0 && nextCapDe > 0 && capAte >= nextCapDe)
          return { erro: true, index: p.originalIndex };
      }
    }

    return { erro: false, index: -1 };
  };

  function handleExtratorStatusChange(
    configuracaoExtratorId: string,
    checked: boolean,
  ): void {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prev) => {
      const newConfig = { ...prev };
      const idx = newConfig.configuracaoExtrator.findIndex(
        (e) => e.configuracaoExtratorId === configuracaoExtratorId,
      );
      if (idx === -1) return newConfig;

      const extrator = { ...newConfig.configuracaoExtrator[idx] };
      extrator.ativo = checked;
      extrator.usuarioEdicao = user;
      extrator.dataEdicao = dataAtual;

      extrator.configuracaoExtratorParametro =
        extrator.configuracaoExtratorParametro?.map((p) => ({
          ...p,
          usuarioEdicao: user,
          dataEdicao: dataAtual,
        })) || [];

      newConfig.configuracaoExtrator = [
        ...newConfig.configuracaoExtrator.slice(0, idx),
        extrator,
        ...newConfig.configuracaoExtrator.slice(idx + 1),
      ];

      newConfig.usuarioEdicao = user;
      newConfig.dataEdicao = dataAtual;

      return newConfig;
    });
  }

  const handleNovaEmpresa = () => {
    if (!configuracaoCompleta || !configuracaoCompleta.configuracaoId) {
      alert(
        "Por favor, selecione uma empresa base primeiro para usar como template.",
      );
      return;
    }

    const confirmacao = window.confirm(
      "Isso criará uma nova empresa copiando a estrutura da atual. As configurações serão independentes. Deseja continuar?",
    );
    if (!confirmacao) return;

    const newConfigId = generateTempId();
    const newEmpresaId = generateTempId();
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    const cloneBase: ConfiguracaoCompleta = JSON.parse(
      JSON.stringify(configuracaoCompleta),
    );

    const cloneIsolado: ConfiguracaoCompleta = {
      ...cloneBase,
      configuracaoId: newConfigId,
      empresaId: newEmpresaId,
      usuarioInclusao: user,
      dataEdicao: dataAtual,
      usuarioEdicao: user,
      empresa: {
        ...estadoInicialEmpresa,
        empresaId: newEmpresaId,
        dataInclusao: dataAtual,
        usuarioInclusao: user,
        dataEdicao: dataAtual,
        usuarioEdicao: user,
        dataFundacao: "",
      },
    };

    cloneIsolado.configuracaoPorte =
      cloneBase.configuracaoPorte?.map((porte) => {
        const novoPorteId = generateTempId();
        return {
          ...porte,
          configuracaoPorteId: novoPorteId,
          configuracaoId: newConfigId,
          usuarioInclusao: user,
          dataEdicao: dataAtual,
          usuarioEdicao: user,
          configuracaoClassificacaoInterna:
            porte.configuracaoClassificacaoInterna?.map((ci) => ({
              ...ci,
              configuracaoClassificacaoInternaId: generateTempId(),
              configuracaoPorteId: novoPorteId,
              usuarioInclusao: user,
              dataEdicao: dataAtual,
              usuarioEdicao: user,
            })),
          configuracaoCriterio: porte.configuracaoCriterio?.map((c) => ({
            ...c,
            configuracaoCriterioId: generateTempId(),
            configuracaoPorteId: novoPorteId,
            usuarioInclusao: user,
            dataEdicao: dataAtual,
            usuarioEdicao: user,
          })),
          configuracaoListaSuja: porte.configuracaoListaSuja?.map((ls) => ({
            ...ls,
            configuracaoListaSujaId: generateTempId(),
            configuracaoPorteId: novoPorteId,
            usuarioInclusao: user,
            dataEdicao: dataAtual,
            usuarioEdicao: user,
          })),
          configuracaoRestritivo: porte.configuracaoRestritivo?.map((r) => ({
            ...r,
            configuracaoRestritivoId: generateTempId(),
            configuracaoPorteId: novoPorteId,
            usuarioInclusao: user,
            dataEdicao: dataAtual,
            usuarioEdicao: user,
          })),
          configuracaoTempoFundacao: porte.configuracaoTempoFundacao?.map(
            (tf) => ({
              ...tf,
              configuracaoTempoFundacaoId: generateTempId(),
              configuracaoPorteId: novoPorteId,
              usuarioInclusao: user,
              dataEdicao: dataAtual,
              usuarioEdicao: user,
            }),
          ),
        };
      }) || [];

    cloneIsolado.configuracaoExtrator =
      cloneBase.configuracaoExtrator?.map((ext) => {
        const novoExtratorId = generateTempId();
        return {
          ...ext,
          configuracaoExtratorId: novoExtratorId,
          configuracaoId: newConfigId,
          usuarioInclusao: user,
          dataEdicao: dataAtual,
          usuarioEdicao: user,
          configuracaoExtratorParametro: ext.configuracaoExtratorParametro?.map(
            (param) => ({
              ...param,
              configuracaoExtratorParametroId: generateTempId(),
              configuracaoExtratorId: novoExtratorId,
              usuarioInclusao: user,
              dataEdicao: dataAtual,
              usuarioEdicao: user,
            }),
          ),
        };
      }) || [];

    cloneIsolado.promptAzure =
      cloneBase.promptAzure?.map((p) => ({
        ...p,
        promptAzureId: generateTempId(),
        configuracaoId: newConfigId,
        usuarioInclusao: user,
        dataEdicao: dataAtual,
        usuarioEdicao: user,
      })) || [];

    cloneIsolado.configuracaoGarantiaComposicao = [];
    cloneIsolado.configuracaoEmailBrt = undefined;

    setEmpresaSelecionada(null);
    setGarantiaIdsPersistidos(new Set());
    setConfiguracaoCompleta(cloneIsolado);
    setErroIntervalo({ erro: false, index: -1 });
    setErrosGarantias([]);
  };

  // --- HANDLERS PARA INDICADORES DA EMPRESA (DRE/BALANÇO) ---

  const handleAddIndicadorEmpresa = () => {
    const user = userLogged ? globalUser?.login || "" : "";
    const dataAtual = new Date().toISOString();

    setConfiguracaoCompleta((prev) => ({
      ...prev,
      configuracaoIndicadoresEmpresa: [
        ...(prev.configuracaoIndicadoresEmpresa || []),
        {
          id: generateTempId(),
          empresaId: prev.empresaId || prev.empresa?.empresaId || GUID_VAZIO,
          codigo: 0,
          descricao: "",
          secao: "Ativo Circulante", // Valor padrão sugerido
          ordemApresentacao:
            (prev.configuracaoIndicadoresEmpresa?.length || 0) + 1,
          usuarioInclusao: user,
          dataInclusao: dataAtual,
        },
      ],
    }));
  };

  const handleChangeIndicadorEmpresa = (
    id: string,
    field: keyof ConfiguracaoIndicadoresEmpresa,
    value: any,
  ) => {
    setConfiguracaoCompleta((prev) => {
      const newConfig = { ...prev };
      newConfig.configuracaoIndicadoresEmpresa = (
        newConfig.configuracaoIndicadoresEmpresa || []
      ).map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [field]:
              field === "codigo" || field === "ordemApresentacao"
                ? Number(value)
                : value,
          };
        }
        return item;
      });
      return newConfig;
    });
  };

  const handleRemoveIndicadorEmpresa = (id: string) => {
    setConfiguracaoCompleta((prev) => ({
      ...prev,
      configuracaoIndicadoresEmpresa: (
        prev.configuracaoIndicadoresEmpresa || []
      ).filter((item) => item.id !== id),
    }));
  };

  const buscarEmpresas = async (paginaAtual: number) => {
    if (carregandoEmpresas || !temMaisEmpresas) return;

    setCarregandoEmpresas(true);
    try {
      const config = { headers: headers() };

      const { data } = await apiOperation.get<any>(
        `/configuracao/listar-empresas?pagina=${paginaAtual}&tamanhoPagina=20`,
        config,
      );

      if (data && !data.erro && Array.isArray(data.valor)) {
        const empresasMapeadas = data.valor.map((empresa: any) => ({
          empresaId: empresa.empresaId,
          label: empresa.razao || empresa.nomeFantasia || "Empresa sem nome",
        }));

        if (data.valor.length < 20) {
          setTemMaisEmpresas(false);
        }

        setListaEmpresas((prev) =>
          paginaAtual === 1 ? empresasMapeadas : [...prev, ...empresasMapeadas],
        );
      }
    } catch (error) {
      console.error("Erro ao buscar a lista de empresas:", error);
    } finally {
      setCarregandoEmpresas(false);
    }
  };

  useEffect(() => {
    const admin = hasAdminUser();
    setIsAdmin(admin);

    if (admin) {
      buscarEmpresas(1);
    } else {
      buscarConfiguracoesCompletas();
    }
  }, []);

  const handleScrollEmpresas = (event: React.UIEvent<HTMLUListElement>) => {
    const listboxNode = event.currentTarget;
    if (
      listboxNode.scrollTop + listboxNode.clientHeight >=
      listboxNode.scrollHeight - 10
    ) {
      if (!carregandoEmpresas && temMaisEmpresas) {
        const proximaPagina = paginaEmpresas + 1;
        setPaginaEmpresas(proximaPagina);
        buscarEmpresas(proximaPagina);
      }
    }
  };

  const mostrarColunasRelacionamento = configuracaoCompleta.utilizaPoliticaNova;

  const OPCOES_SECAO_CONTABIL = [
    "Ativo Circulante",
    "Ativo Não Circulante",
    "Passivo Circulante",
    "Passivo Não Circulante",
    "Patrimônio Líquido",
    "Custos",
    "Resultado",
  ];

  // Identifica qual é o Tipo de Pessoa (Física/Jurídica) unificado atual da tabela de Análise Simplificada
  const porteAnS =
    configuracaoCompleta.configuracaoPorte[porteSelecionadoIndex];
  const criteriosAnS = porteAnS?.configuracaoCriterioAnaliseSimplificada || [];
  return (
    <>
      <Header />
      <Box sx={{ bgcolor: "#f8fafc", minHeight: "100vh", pb: 10 }}>
        <Container
          style={{ width: "90%", maxWidth: "1440px", margin: "0 auto" }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", md: "center" }}
            mt={2}
            mb={5}
            px={1}
            spacing={2}
          >
            <Box>
              <Typography
                variant="h4"
                fontWeight="800"
                mt={2}
                color="text.primary"
                letterSpacing="-0.5px"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <Settings color="primary" fontSize="large" /> Configurações do
                Sistema
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                fontWeight="500"
                mt={0.5}
                ml={1}
              >
                Gerencie parâmetros, inteligência artificial e políticas de
                crédito
              </Typography>
            </Box>

            {!isAdmin && (
              <Box
                display="flex"
                paddingTop={2}
                alignItems="stretch"
                gap={2}
                pr={{ xs: 0, md: 2 }}
              >
                <EmbededSuporteComponent />
                <EmbededInstructionsComponent
                  mostrarSecaoGarantias={isEmpresaRdp}
                />
              </Box>
            )}
          </Stack>

          <Content>
            {isAdmin && (
              <Card
                elevation={0}
                sx={{
                  ...modernCardStyle,
                  mb: 4,
                  borderLeft: "6px solid #1976d2",
                  width: "100%",
                  maxWidth: "900px",
                  mx: "auto",
                }}
              >
                <Typography variant="h6" color="primary" gutterBottom>
                  <Business sx={{ verticalAlign: "middle", mr: 1 }} /> Seleção
                  de Empresa (Admin)
                </Typography>
                <Grid container spacing={3} alignItems="center" mt={1}>
                  <Grid item xs={12} sm={8}>
                    <Autocomplete
                      options={listaEmpresas}
                      getOptionLabel={(option) => option.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.empresaId === value.empresaId
                      }
                      value={empresaSelecionada}
                      onChange={handleEmpresaChange}
                      loading={carregandoEmpresas}
                      ListboxProps={{
                        onScroll: handleScrollEmpresas,
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecione ou busque a empresa"
                          variant="outlined"
                          size="small"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {carregandoEmpresas ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ height: "40px", borderRadius: 2 }}
                      onClick={handleNovaEmpresa}
                      startIcon={<Add />}
                    >
                      Nova Empresa
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            )}

            {configuracaoCompleta.empresa &&
            configuracaoCompleta.empresa.empresaId ? (
              <Box sx={{ width: "100%", pb: 10 }}>
                {/* 1. DADOS DA EMPRESA */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <Business color="action" /> Dados da Empresa
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="cnpjOuCpf"
                          value={configuracaoCompleta.empresa.cnpjOuCpf}
                          onChange={(e) => {
                            const { value } = e.target;
                            setConfiguracaoCompleta((prev) => ({
                              ...prev,
                              empresa: { ...prev.empresa, cnpjOuCpf: value },
                            }));
                          }}
                          label="CNPJ ou CPF"
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="razao"
                          value={configuracaoCompleta.empresa.razao}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            setConfiguracaoCompleta((prev) => ({
                              ...prev,
                              empresa: { ...prev.empresa, [name]: value },
                            }));
                          }}
                          label="Razão Social"
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="nomeFantasia"
                          value={configuracaoCompleta.empresa.nomeFantasia}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            setConfiguracaoCompleta((prev) => ({
                              ...prev,
                              empresa: { ...prev.empresa, [name]: value },
                            }));
                          }}
                          label="Nome Fantasia"
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="dataFundacao"
                          value={configuracaoCompleta.empresa.dataFundacao}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            setConfiguracaoCompleta((prev) => ({
                              ...prev,
                              empresa: { ...prev.empresa, [name]: value },
                            }));
                          }}
                          label="Data de Fundação"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="naturezaJuridica"
                          value={configuracaoCompleta.empresa.naturezaJuridica}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            setConfiguracaoCompleta((prev) => ({
                              ...prev,
                              empresa: { ...prev.empresa, [name]: value },
                            }));
                          }}
                          label="Natureza Jurídica"
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="email"
                          value={configuracaoCompleta.empresa.email}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            setConfiguracaoCompleta((prev) => ({
                              ...prev,
                              empresa: { ...prev.empresa, [name]: value },
                            }));
                          }}
                          label="Email"
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="endereco"
                          value={configuracaoCompleta.empresa.endereco}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            setConfiguracaoCompleta((prev) => ({
                              ...prev,
                              empresa: { ...prev.empresa, [name]: value },
                            }));
                          }}
                          label="Endereço"
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              name="bairro"
                              value={configuracaoCompleta.empresa.bairro}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setConfiguracaoCompleta((prev) => ({
                                  ...prev,
                                  empresa: { ...prev.empresa, [name]: value },
                                }));
                              }}
                              label="Bairro"
                              fullWidth
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              name="cidade"
                              value={configuracaoCompleta.empresa.cidade}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setConfiguracaoCompleta((prev) => ({
                                  ...prev,
                                  empresa: { ...prev.empresa, [name]: value },
                                }));
                              }}
                              label="Cidade"
                              fullWidth
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              name="estado"
                              value={configuracaoCompleta.empresa.estado}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setConfiguracaoCompleta((prev) => ({
                                  ...prev,
                                  empresa: { ...prev.empresa, [name]: value },
                                }));
                              }}
                              label="Estado"
                              fullWidth
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              name="cep"
                              value={configuracaoCompleta.empresa.cep}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setConfiguracaoCompleta((prev) => ({
                                  ...prev,
                                  empresa: { ...prev.empresa, [name]: value },
                                }));
                              }}
                              label="CEP"
                              fullWidth
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Grid
                          container
                          spacing={2}
                          alignItems="center"
                          height="100%"
                        >
                          <Grid item xs={6}>
                            <TextField
                              name="situacao"
                              value={configuracaoCompleta.empresa.situacao}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setConfiguracaoCompleta((prev) => ({
                                  ...prev,
                                  empresa: { ...prev.empresa, [name]: value },
                                }));
                              }}
                              label="Situação"
                              fullWidth
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormControlLabel
                              control={
                                <Switch
                                  name="ativo"
                                  checked={configuracaoCompleta.empresa.ativo}
                                  onChange={(e) => {
                                    const { name, checked } = e.target;
                                    setConfiguracaoCompleta((prev) => ({
                                      ...prev,
                                      empresa: {
                                        ...prev.empresa,
                                        [name]: checked,
                                      },
                                    }));
                                  }}
                                />
                              }
                              label="Empresa Ativa"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* 2. POLÍTICAS DE CRÉDITO */}
                {hasAdminUser() && (
                  <Accordion sx={accordionStyle} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h6"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <Security color="action" /> Política de Crédito e
                        Bureaus
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12} md={6}>
                        <FormControl
                          style={{
                            width: "20%",
                            minWidth: "200px",
                            marginBottom: "16px",
                          }}
                          size="small"
                        >
                          <InputLabel id="tipo-motor-label">
                            Motor de Cálculo
                          </InputLabel>
                          <Select
                            labelId="tipo-motor-label"
                            id="tipoMotorCalculo"
                            name="tipoMotorCalculo"
                            value={configuracaoCompleta.tipoMotorCalculo}
                            label="Motor de Cálculo"
                            onChange={handleTipoMotorChange}
                          >
                            {configuracaoCompleta.opcoesMotorCalculo &&
                              Object.entries(
                                configuracaoCompleta.opcoesMotorCalculo,
                              ).map(([value, label]) => (
                                <MenuItem key={value} value={Number(value)}>
                                  {label as string}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <br />
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  configuracaoCompleta.utilizaPoliticaNova
                                }
                                onChange={handleCheckboxChange}
                                name="utilizaPoliticaNova"
                              />
                            }
                            label="Utilizar nova política"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={configuracaoCompleta.possuiBureauSpc}
                                onChange={handleCheckboxChange}
                                name="possuiBureauSpc"
                              />
                            }
                            label="Possui Bureau SPC"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  configuracaoCompleta.possuiBureauSerasa
                                }
                                onChange={handleCheckboxChange}
                                name="possuiBureauSerasa"
                              />
                            }
                            label="Possui Bureau Serasa"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  configuracaoCompleta.possuiBureauBoaVista
                                }
                                onChange={handleCheckboxChange}
                                name="possuiBureauBoaVista"
                              />
                            }
                            label="Possui Bureau Boa Vista"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={configuracaoCompleta.calcularNotaPorte}
                                onChange={handleCheckboxChange}
                                name="calcularNotaPorte"
                              />
                            }
                            label="Calcular Nota de Porte"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  configuracaoCompleta.calcularMediaReceitaLiquida
                                }
                                onChange={handleCheckboxChange}
                                name="calcularMediaReceitaLiquida"
                              />
                            }
                            label="Calcular Média de Receita Líquida"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  configuracaoCompleta.calcularMediaScore
                                }
                                onChange={handleCheckboxChange}
                                name="calcularMediaScore"
                              />
                            }
                            label="Calcular Média de Score"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  configuracaoCompleta.calcularNotaProporcionalDefault
                                }
                                onChange={handleCheckboxChange}
                                name="calcularNotaProporcionalDefault"
                              />
                            }
                            label="Calcular Nota Proporcional de Default"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  configuracaoCompleta.limitarLimiteSugeridoPorValorSolicitado
                                }
                                onChange={handleCheckboxChange}
                                name="limitarLimiteSugeridoPorValorSolicitado"
                              />
                            }
                            label="Limitar Limite Sugerido por Valor Solicitado"
                          />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}

                {/* 3. CMA */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <Gavel color="action" /> Critérios Mínimos de Aceitação
                      (CMA)
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={
                                configuracaoCompleta.recusaEmpresaNaoAtivaNaReceita
                              }
                              onChange={handleCheckboxChange}
                              name="recusaEmpresaNaoAtivaNaReceita"
                            />
                          }
                          label="Recusar empresa não ativa na Receita"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={
                                configuracaoCompleta.recusaEmpresaRecuperacaoJudicial
                              }
                              onChange={handleCheckboxChange}
                              name="recusaEmpresaRecuperacaoJudicial"
                            />
                          }
                          label="Recusar empresa em recuperação judicial"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={
                                configuracaoCompleta.recusaEmpresaBaixadaNoSintegra
                              }
                              onChange={handleCheckboxChange}
                              name="recusaEmpresaBaixadaNoSintegra"
                            />
                          }
                          label="Recusar empresa baixada no Sintegra"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={
                                configuracaoCompleta.recusaEmpresaComFundacaoMenorQueTempoMinimo
                              }
                              onChange={handleCheckboxChange}
                              name="recusaEmpresaComFundacaoMenorQueTempoMinimo"
                            />
                          }
                          label="Recusar por tempo mínimo de fundação"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={
                                configuracaoCompleta.recusaEmpresaComApontamentoNoCeis
                              }
                              onChange={handleCheckboxChange}
                              name="recusaEmpresaComApontamentoNoCeis"
                            />
                          }
                          label="Recusar empresa com apontamento no CEIS"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={
                                configuracaoCompleta.recusaEmpresaComApontamentoNoCnep
                              }
                              onChange={handleCheckboxChange}
                              name="recusaEmpresaComApontamentoNoCnep"
                            />
                          }
                          label="Recusar empresa com apontamento no CENEP"
                        />
                      </Grid>
                      {configuracaoCompleta.recusaEmpresaComFundacaoMenorQueTempoMinimo && (
                        <Grid item xs={12} sm={6}>
                          <TextField
                            name="tempoMinimoFundacao"
                            value={configuracaoCompleta.tempoMinimoFundacao}
                            onChange={handleInputChange}
                            label="Tempo mínimo de fundação (meses)"
                            type="number"
                            fullWidth
                            variant="outlined"
                            size="small"
                            InputProps={{
                              inputProps: { className: "no-spinners" },
                            }}
                            sx={{ mt: 1 }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* 4. CONFIGURAÇÃO DE PORTE */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <BarChart color="action" /> Configuração de Portes
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TableContainer
                      component={Paper}
                      elevation={0}
                      sx={{ border: "1px solid #f0f0f0" }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={tableHeaderStyle}>
                              Classificação
                            </TableCell>
                            <TableCell sx={tableHeaderStyle}>
                              Faturamento (De)
                            </TableCell>
                            <TableCell sx={tableHeaderStyle}>
                              Faturamento (Até)
                            </TableCell>
                            <TableCell sx={tableHeaderStyle}>
                              Capital Social (De)
                            </TableCell>
                            <TableCell sx={tableHeaderStyle}>
                              Capital Social (Até)
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {configuracaoCompleta.configuracaoPorte.map(
                            (porte, index) => (
                              <TableRow key={index} hover>
                                <TableCell>
                                  <TextField
                                    value={porte.descricao}
                                    onChange={(e) =>
                                      handlePorteChange(
                                        index,
                                        "descricao",
                                        e.target.value,
                                      )
                                    }
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    value={porte.de}
                                    error={
                                      erroIntervalo.erro &&
                                      erroIntervalo.index === index
                                    }
                                    onChange={(e) =>
                                      handlePorteChange(
                                        index,
                                        "de",
                                        e.target.value,
                                      )
                                    }
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                      inputProps: { className: "no-spinners" },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    value={porte.ate}
                                    error={
                                      erroIntervalo.erro &&
                                      erroIntervalo.index === index
                                    }
                                    onChange={(e) =>
                                      handlePorteChange(
                                        index,
                                        "ate",
                                        e.target.value,
                                      )
                                    }
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                      inputProps: { className: "no-spinners" },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    value={porte.capitalSocialDe}
                                    error={
                                      erroIntervalo.erro &&
                                      erroIntervalo.index === index
                                    }
                                    onChange={(e) =>
                                      handlePorteChange(
                                        index,
                                        "capitalSocialDe",
                                        e.target.value,
                                      )
                                    }
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                      inputProps: { className: "no-spinners" },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    value={porte.capitalSocialAte}
                                    error={
                                      erroIntervalo.erro &&
                                      erroIntervalo.index === index
                                    }
                                    onChange={(e) =>
                                      handlePorteChange(
                                        index,
                                        "capitalSocialAte",
                                        e.target.value,
                                      )
                                    }
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                      inputProps: { className: "no-spinners" },
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            ),
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>

                {/* 5. INDICADORES PARA ANÁLISE */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <Rule color="action" /> Seleção de Indicadores Ativos
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2} pt={1}>
                      {configuracaoCompleta.configuracaoPorte
                        .filter((porte) => porte.descricao === "Corporate")
                        .map((porte, porteIndex) => (
                          <React.Fragment key={`porte-${porteIndex}`}>
                            {porte.configuracaoCriterio
                              .filter(
                                (criterio, index, self) =>
                                  index ===
                                  self.findIndex(
                                    (t) =>
                                      t.tipoParametro ===
                                      criterio.tipoParametro,
                                  ),
                              )
                              .map((criterio) => (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  lg={3}
                                  key={`criterio-${criterio.configuracaoCriterioId}`}
                                >
                                  <Box
                                    sx={{
                                      border: "1px solid #e2e8f0",
                                      borderRadius: 2,
                                      p: 1.5,
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          checked={criterio.ativo}
                                          onChange={(e) =>
                                            handleIndicadoresChange(
                                              criterio.configuracaoCriterioId,
                                              "ativo",
                                              e.target.checked,
                                            )
                                          }
                                          color="primary"
                                          size="small"
                                        />
                                      }
                                      label={
                                        <Typography
                                          variant="body2"
                                          fontWeight="500"
                                        >
                                          {criterio.descricao}
                                        </Typography>
                                      }
                                      sx={{ m: 0, width: "100%" }}
                                    />
                                  </Box>
                                </Grid>
                              ))}
                          </React.Fragment>
                        ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* 6. PESOS DOS INDICADORES */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <AssignmentTurnedIn color="action" /> Pesos dos
                      Indicadores
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{ mb: 3, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
                    >
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={4} md={3}>
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                          >
                            <InputLabel id="select-porte-pesos-label">
                              Visualizando Porte:
                            </InputLabel>
                            <Select
                              labelId="select-porte-pesos-label"
                              value={porteSelecionadoIndex}
                              onChange={(e) =>
                                setPorteSelecionadoIndex(Number(e.target.value))
                              }
                              label="Visualizando Porte:"
                              sx={{ bgcolor: "white" }}
                            >
                              {configuracaoCompleta.configuracaoPorte.map(
                                (porte, index) => (
                                  <MenuItem key={index} value={index}>
                                    {porte.descricao || `Porte ${index + 1}`}
                                  </MenuItem>
                                ),
                              )}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={8} md={9}>
                          {isEmpresaRdp && algumPorteSemCriterioGarantias && (
                            <Alert
                              severity="warning"
                              icon={false}
                              action={
                                <Button
                                  variant="contained"
                                  color="warning"
                                  size="small"
                                  onClick={
                                    handleIncluirCriterioGarantiasTodosPortes
                                  }
                                >
                                  Adicionar Garantias
                                </Button>
                              }
                            >
                              Alguns portes estão sem o critério de{" "}
                              <strong>Garantias</strong>. Adicione-o para evitar
                              falhas no cálculo.
                            </Alert>
                          )}
                        </Grid>
                      </Grid>
                    </Box>

                    {isEmpresaRdp && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          mb: 2,
                          p: 1.5,
                          bgcolor: "rgba(25, 118, 210, 0.04)",
                          borderRadius: 2,
                          borderLeft: "4px solid #1976d2",
                        }}
                      >
                        <strong>Garantias:</strong> edite o peso em cada coluna
                        (como os demais indicadores) e clique em{" "}
                        <strong>Salvar configurações</strong> — os valores vão
                        para a base e serão usados no cálculo da nota. Na
                        análise: pontuação = peso cadastrado × fator da
                        composição × (% de cobertura ÷ 100). Redistribua os
                        pesos para totalizar <strong>100%</strong> em cada
                        coluna.
                      </Typography>
                    )}

                    <TableContainer
                      component={Paper}
                      elevation={0}
                      sx={{ border: "1px solid #f0f0f0" }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={tableHeaderStyle}>
                              Indicador
                            </TableCell>
                            <TableCell sx={tableHeaderStyle} width="15%">
                              Com Doc. (%)
                            </TableCell>
                            <TableCell sx={tableHeaderStyle} width="15%">
                              Sem Doc. (%)
                            </TableCell>
                            {mostrarColunasRelacionamento && (
                              <>
                                <TableCell sx={tableHeaderStyle} width="15%">
                                  Com Doc. Rel. Def. (%)
                                </TableCell>
                                <TableCell sx={tableHeaderStyle} width="15%">
                                  Sem Doc. Rel. Def. (%)
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {configuracaoCompleta.configuracaoPorte[
                            porteSelecionadoIndex
                          ] &&
                            configuracaoCompleta.configuracaoPorte[
                              porteSelecionadoIndex
                            ].configuracaoCriterio
                              .filter((criterio) =>
                                criterioVisivelGradePesos(criterio),
                              )
                              .filter(
                                (criterio, index, self) =>
                                  index ===
                                  self.findIndex(
                                    (t) =>
                                      t.tipoParametro ===
                                      criterio.tipoParametro,
                                  ),
                              )
                              .map((criterio) => (
                                <TableRow
                                  key={criterio.configuracaoCriterioId}
                                  hover
                                  sx={
                                    isEmpresaRdp &&
                                    isCriterioGarantias(criterio.tipoParametro)
                                      ? { bgcolor: "rgba(25, 118, 210, 0.04)" }
                                      : undefined
                                  }
                                >
                                  <TableCell>
                                    <Typography
                                      variant="body2"
                                      fontWeight="500"
                                    >
                                      {criterio.descricao}
                                    </Typography>
                                    {isEmpresaRdp &&
                                      isCriterioGarantias(
                                        criterio.tipoParametro,
                                      ) && (
                                        <Chip
                                          label="Garantias"
                                          size="small"
                                          color="primary"
                                          sx={{
                                            ml: 1,
                                            height: 20,
                                            fontSize: "0.65rem",
                                          }}
                                        />
                                      )}
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      value={criterio.pesoComDocumentacao}
                                      onChange={(e) =>
                                        handleCriterioChange(
                                          porteSelecionadoIndex,
                                          "pesoComDocumentacao",
                                          e.target.value,
                                          criterio.descricao,
                                        )
                                      }
                                      type="number"
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      InputProps={{
                                        inputProps: {
                                          className: "no-spinners",
                                        },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      value={criterio.pesoSemDocumentacao}
                                      onChange={(e) =>
                                        handleCriterioChange(
                                          porteSelecionadoIndex,
                                          "pesoSemDocumentacao",
                                          e.target.value,
                                          criterio.descricao,
                                        )
                                      }
                                      type="number"
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      InputProps={{
                                        inputProps: {
                                          className: "no-spinners",
                                        },
                                      }}
                                    />
                                  </TableCell>
                                  {mostrarColunasRelacionamento && (
                                    <>
                                      <TableCell>
                                        <TextField
                                          value={
                                            criterio.pesoComDocumentacaoRelacionamentoDefinido
                                          }
                                          onChange={(e) =>
                                            handleCriterioChange(
                                              porteSelecionadoIndex,
                                              "pesoComDocumentacaoRelacionamentoDefinido",
                                              e.target.value,
                                              criterio.descricao,
                                            )
                                          }
                                          type="number"
                                          fullWidth
                                          variant="outlined"
                                          size="small"
                                          InputProps={{
                                            inputProps: {
                                              className: "no-spinners",
                                            },
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          value={
                                            criterio.pesoSemDocumentacaoRelacionamentoDefinido
                                          }
                                          onChange={(e) =>
                                            handleCriterioChange(
                                              porteSelecionadoIndex,
                                              "pesoSemDocumentacaoRelacionamentoDefinido",
                                              e.target.value,
                                              criterio.descricao,
                                            )
                                          }
                                          type="number"
                                          fullWidth
                                          variant="outlined"
                                          size="small"
                                          InputProps={{
                                            inputProps: {
                                              className: "no-spinners",
                                            },
                                          }}
                                        />
                                      </TableCell>
                                    </>
                                  )}
                                </TableRow>
                              ))}
                          <TableRow sx={{ bgcolor: "#f8fafc" }}>
                            <TableCell>
                              <Typography variant="subtitle2">
                                TOTAL (
                                {
                                  configuracaoCompleta.configuracaoPorte[
                                    porteSelecionadoIndex
                                  ]?.descricao
                                }
                                )
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                color={
                                  calcularTotalColuna("pesoComDocumentacao") ===
                                  100
                                    ? "success.main"
                                    : "error.main"
                                }
                              >
                                {calcularTotalColuna("pesoComDocumentacao")}%
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                color={
                                  calcularTotalColuna("pesoSemDocumentacao") ===
                                  100
                                    ? "success.main"
                                    : "error.main"
                                }
                              >
                                {calcularTotalColuna("pesoSemDocumentacao")}%
                              </Typography>
                            </TableCell>
                            {mostrarColunasRelacionamento && (
                              <>
                                <TableCell>
                                  <Typography
                                    variant="subtitle2"
                                    color={
                                      calcularTotalColuna(
                                        "pesoComDocumentacaoRelacionamentoDefinido",
                                      ) === 100
                                        ? "success.main"
                                        : "error.main"
                                    }
                                  >
                                    {calcularTotalColuna(
                                      "pesoComDocumentacaoRelacionamentoDefinido",
                                    )}
                                    %
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="subtitle2"
                                    color={
                                      calcularTotalColuna(
                                        "pesoSemDocumentacaoRelacionamentoDefinido",
                                      ) === 100
                                        ? "success.main"
                                        : "error.main"
                                    }
                                  >
                                    {calcularTotalColuna(
                                      "pesoSemDocumentacaoRelacionamentoDefinido",
                                    )}
                                    %
                                  </Typography>
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {!validarSomaTotal() && (
                      <Alert severity="error" sx={{ mt: 2 }}>
                        A soma dos pesos deve ser exatamente{" "}
                        <strong>100%</strong> em todas as colunas para o porte
                        selecionado.
                      </Alert>
                    )}
                  </AccordionDetails>
                </Accordion>

                {/* 7. INDICADORES FINANCEIROS */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <AccountBalanceWallet color="action" /> Metas Financeiras
                      (Indicador Esperado)
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{ mb: 3, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
                    >
                      <FormControl
                        variant="outlined"
                        size="small"
                        sx={{
                          width: { xs: "100%", sm: "250px" },
                          bgcolor: "white",
                        }}
                      >
                        <InputLabel>Visualizando Porte:</InputLabel>
                        <Select
                          value={porteSelecionadoIndex}
                          onChange={(e) =>
                            setPorteSelecionadoIndex(Number(e.target.value))
                          }
                          label="Visualizando Porte:"
                        >
                          {configuracaoCompleta.configuracaoPorte.map(
                            (porte, index) => (
                              <MenuItem key={index} value={index}>
                                {porte.descricao || `Porte ${index + 1}`}
                              </MenuItem>
                            ),
                          )}
                        </Select>
                      </FormControl>
                    </Box>
                    {(() => {
                      const porteSelecionado =
                        configuracaoCompleta.configuracaoPorte[
                          porteSelecionadoIndex
                        ];
                      if (!porteSelecionado) return null;

                      const idsFinanceiros = [
                        36,
                        38,
                        39,
                        40,
                        219,
                        TIPO_PARAMETRO_GARANTIAS,
                      ];
                      const indicadoresUnicos =
                        porteSelecionado.configuracaoCriterio
                          .filter(
                            (ind) =>
                              ind.ativo &&
                              (ind.tipoCriterio === "0" ||
                                ind.tipoCriterio === null ||
                                ind.tipoCriterio === undefined) &&
                              !idsFinanceiros.includes(
                                Number(ind.tipoParametro),
                              ),
                          )
                          .filter(
                            (ind, index, self) =>
                              index ===
                              self.findIndex(
                                (t) => t.descricao === ind.descricao,
                              ),
                          );

                      if (indicadoresUnicos.length > 0) {
                        return (
                          <Grid container spacing={2}>
                            {indicadoresUnicos.map((indicador, index) => (
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                key={indicador.configuracaoCriterioId || index}
                              >
                                <Box
                                  sx={{
                                    border: "1px solid #e2e8f0",
                                    borderRadius: 2,
                                    p: 1.5,
                                    bgcolor: "#fafbfc",
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    display="block"
                                    mb={1}
                                    color="textSecondary"
                                    sx={{ minHeight: 32 }}
                                  >
                                    {indicador.descricao}
                                  </Typography>
                                  <TextField
                                    value={indicador.indicadorEsperado}
                                    onChange={(e) =>
                                      handleValueChange(e, indicador.descricao)
                                    }
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    InputProps={{ className: "no-spinners" }}
                                    sx={{ bgcolor: "white" }}
                                  />
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        );
                      }
                      return (
                        <Typography variant="body2" color="textSecondary">
                          Nenhum indicador financeiro configurado para este
                          porte.
                        </Typography>
                      );
                    })()}
                  </AccordionDetails>
                </Accordion>

                {/* 8. CLASSIFICAÇÃO INTERNA */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <BarChart color="action" /> Classificação Interna
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{ mb: 3, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
                    >
                      <FormControl
                        variant="outlined"
                        size="small"
                        sx={{
                          width: { xs: "100%", sm: "250px" },
                          bgcolor: "white",
                        }}
                      >
                        <InputLabel>Visualizando Porte:</InputLabel>
                        <Select
                          value={porteSelecionadoIndex}
                          onChange={(e) =>
                            setPorteSelecionadoIndex(Number(e.target.value))
                          }
                          label="Visualizando Porte:"
                        >
                          {configuracaoCompleta.configuracaoPorte.map(
                            (porte, index) => (
                              <MenuItem key={index} value={index}>
                                {porte.descricao || `Porte ${index + 1}`}
                              </MenuItem>
                            ),
                          )}
                        </Select>
                      </FormControl>
                    </Box>
                    <TableContainer
                      component={Paper}
                      elevation={0}
                      sx={{ border: "1px solid #f0f0f0" }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={tableHeaderStyle}>
                              Classificação
                            </TableCell>
                            {hasAdminUser() && (
                              <TableCell sx={tableHeaderStyle}>De</TableCell>
                            )}
                            {hasAdminUser() && (
                              <TableCell sx={tableHeaderStyle}>Até</TableCell>
                            )}
                            <TableCell sx={tableHeaderStyle}>Nota</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(() => {
                            const porte =
                              configuracaoCompleta.configuracaoPorte[
                                porteSelecionadoIndex
                              ];
                            if (!porte) return null;

                            const isTipoPessoa1 =
                              porte.configuracaoCriterio.find(
                                (c) => String(c.tipoPessoa) === "1",
                              );

                            if (!isTipoPessoa1) {
                              return (
                                <TableRow>
                                  <TableCell
                                    colSpan={4}
                                    align="center"
                                    sx={{ py: 4, color: "text.secondary" }}
                                  >
                                    A Classificação Interna não se aplica a este
                                    porte (Válido apenas para Tipo Pessoa = 1).
                                  </TableCell>
                                </TableRow>
                              );
                            }

                            const linhas = [
                              { tipo: 3, label: "Ótimo" },
                              { tipo: 2, label: "Bom" },
                              { tipo: 1, label: "Ruim" },
                            ];

                            return linhas.map((linha) => {
                              const classif = (
                                porte.configuracaoClassificacaoInterna || []
                              ).find(
                                (c) =>
                                  Number(c.tipoClassificacao) === linha.tipo,
                              );

                              return (
                                <TableRow key={`classif-${linha.tipo}`} hover>
                                  <TableCell>
                                    <Typography
                                      variant="body2"
                                      fontWeight="500"
                                    >
                                      {linha.label}
                                    </Typography>
                                  </TableCell>
                                  {hasAdminUser() && (
                                    <>
                                      <TableCell>
                                        <TextField
                                          value={classif?.de || 0}
                                          onChange={(e) =>
                                            handleClassificacaoInternaChange(
                                              porteSelecionadoIndex,
                                              linha.tipo,
                                              "de",
                                              Number(e.target.value),
                                            )
                                          }
                                          type="number"
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          InputProps={{
                                            className: "no-spinners",
                                          }}
                                          onFocus={(e) => e.target.select()}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          value={classif?.ate || 0}
                                          onChange={(e) =>
                                            handleClassificacaoInternaChange(
                                              porteSelecionadoIndex,
                                              linha.tipo,
                                              "ate",
                                              Number(e.target.value),
                                            )
                                          }
                                          type="number"
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          InputProps={{
                                            className: "no-spinners",
                                          }}
                                          onFocus={(e) => e.target.select()}
                                        />
                                      </TableCell>
                                    </>
                                  )}
                                  <TableCell>
                                    <TextField
                                      value={classif?.nota || 0}
                                      onChange={(e) =>
                                        handleClassificacaoInternaChange(
                                          porteSelecionadoIndex,
                                          linha.tipo,
                                          "nota",
                                          Number(e.target.value),
                                        )
                                      }
                                      type="number"
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      InputProps={{ className: "no-spinners" }}
                                      onFocus={(e) => e.target.select()}
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            });
                          })()}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>

                {/* ANÁLISE SIMPLIFICADA */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <Rule color="action" /> Parâmetros de Pré-análise
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{
                        mb: 3,
                        p: 2,
                        bgcolor: "#f8fafc",
                        borderRadius: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      <Box display="flex" gap={2} flexWrap="wrap">
                        <FormControl
                          variant="outlined"
                          size="small"
                          sx={{
                            width: { xs: "100%", sm: "250px" },
                            bgcolor: "white",
                          }}
                        >
                          <InputLabel>Visualizando Porte:</InputLabel>
                          <Select
                            value={porteSelecionadoIndex}
                            onChange={(e) =>
                              setPorteSelecionadoIndex(Number(e.target.value))
                            }
                            label="Visualizando Porte:"
                          >
                            {configuracaoCompleta.configuracaoPorte.map(
                              (porte, index) => (
                                <MenuItem key={index} value={index}>
                                  {porte.descricao || `Porte ${index + 1}`}
                                </MenuItem>
                              ),
                            )}
                          </Select>
                        </FormControl>
                      </Box>

                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleAddCriterioAnaliseSimplificada}
                        startIcon={<Add />}
                        sx={{ borderRadius: 2 }}
                      >
                        Novo Critério
                      </Button>
                    </Box>

                    <TableContainer
                      component={Paper}
                      elevation={0}
                      sx={{ border: "1px solid #f0f0f0" }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={tableHeaderStyle}>
                              Parâmetro / Indicador
                            </TableCell>
                            <TableCell sx={tableHeaderStyle} width="15%">
                              Ind. Esperado
                            </TableCell>
                            <TableCell sx={tableHeaderStyle} width="15%">
                              Peso (%)
                            </TableCell>
                            <TableCell
                              sx={tableHeaderStyle}
                              align="center"
                              width="10%"
                            >
                              Ativo
                            </TableCell>
                            <TableCell
                              sx={tableHeaderStyle}
                              align="center"
                              width="10%"
                            >
                              Ações
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(() => {
                            const porte =
                              configuracaoCompleta.configuracaoPorte[
                                porteSelecionadoIndex
                              ];
                            if (!porte) return null;

                            const criterios =
                              porte.configuracaoCriterioAnaliseSimplificada ||
                              [];

                            // A pré-análise é parametrizada somente para pessoa jurídica.
                            const criteriosExibidos = criterios
                              .map((c, originalIdx) => ({ ...c, originalIdx }))
                              .filter((c) => (c.tipoPessoa ?? 1) === 1);

                            if (criteriosExibidos.length === 0) {
                              return (
                                <TableRow>
                                  <TableCell
                                    colSpan={5}
                                    align="center"
                                    sx={{ py: 4, color: "text.secondary" }}
                                  >
                                    Nenhum critério de pessoa jurídica
                                    configurado para este porte.
                                  </TableCell>
                                </TableRow>
                              );
                            }

                            // Calcula a soma da tela atual
                            const totalPesoDaTela = criteriosExibidos
                              .filter((c) => c.ativo)
                              .reduce(
                                (acc, curr) => acc + Number(curr.peso || 0),
                                0,
                              );

                            return (
                              <React.Fragment>
                                {criteriosExibidos.map((criterio) => (
                                  <TableRow
                                    key={
                                      criterio.configuracaoCriterioAnaliseSimplificadaId ||
                                      criterio.originalIdx
                                    }
                                    hover
                                  >
                                    <TableCell>
                                      <FormControl
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                      >
                                        <Select
                                          value={String(
                                            criterio.tipoParametro || "",
                                          )}
                                          onChange={(e) =>
                                            handleChangeCriterioAnaliseSimplificada(
                                              criterio.originalIdx,
                                              "tipoParametro",
                                              e.target.value,
                                            )
                                          }
                                          displayEmpty
                                          sx={{ bgcolor: "white" }}
                                        >
                                          <MenuItem value="0" disabled>
                                            Selecione o Parâmetro...
                                          </MenuItem>
                                          {CATALOGO_PARAMETROS.map((op) => (
                                            <MenuItem
                                              key={op.id}
                                              value={String(op.id)}
                                            >
                                              {op.label}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell>
                                      <TextField
                                        value={criterio.indicadorEsperado}
                                        onChange={(e) =>
                                          handleChangeCriterioAnaliseSimplificada(
                                            criterio.originalIdx,
                                            "indicadorEsperado",
                                            e.target.value,
                                          )
                                        }
                                        type="number"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                          className: "no-spinners",
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <TextField
                                        value={criterio.peso}
                                        onChange={(e) =>
                                          handleChangeCriterioAnaliseSimplificada(
                                            criterio.originalIdx,
                                            "peso",
                                            e.target.value,
                                          )
                                        }
                                        type="number"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                          className: "no-spinners",
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      <Switch
                                        checked={criterio.ativo}
                                        onChange={(e) =>
                                          handleChangeCriterioAnaliseSimplificada(
                                            criterio.originalIdx,
                                            "ativo",
                                            e.target.checked,
                                          )
                                        }
                                        color="primary"
                                        size="small"
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      <Button
                                        size="small"
                                        color="error"
                                        onClick={() =>
                                          handleRemoveCriterioAnaliseSimplificada(
                                            criterio.originalIdx,
                                          )
                                        }
                                      >
                                        Remover
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                ))}

                                {/* LINHA DE TOTALIZADOR */}
                                <TableRow sx={{ bgcolor: "#f8fafc" }}>
                                  <TableCell colSpan={2} align="right">
                                    <Typography variant="subtitle2">
                                      TOTAL DA TELA (Ativos):
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography
                                      variant="subtitle2"
                                      color={
                                        totalPesoDaTela === 100
                                          ? "success.main"
                                          : "error.main"
                                      }
                                    >
                                      PJ: {totalPesoDaTela}%
                                    </Typography>
                                  </TableCell>
                                  <TableCell colSpan={2}></TableCell>
                                </TableRow>
                              </React.Fragment>
                            );
                          })()}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {!validarSomaAnaliseSimplificada() && (
                      <Alert severity="error" sx={{ mt: 2 }}>
                        A soma dos pesos deve ser exatamente{" "}
                        <strong>100%</strong> no porte selecionado.
                      </Alert>
                    )}
                  </AccordionDetails>
                </Accordion>

                {/* 9. LISTA SUJA */}
                {configuracaoCompleta.configuracaoPorte.some((p) =>
                  p.configuracaoCriterio.some(
                    (c) => c.descricao === "Lista Suja",
                  ),
                ) && (
                  <Accordion sx={accordionStyle} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h6"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <Rule color="action" /> Lista Suja (CEIS / CNEP / CEPIM)
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <TableContainer
                        component={Paper}
                        elevation={0}
                        sx={{ border: "1px solid #f0f0f0" }}
                      >
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={tableHeaderStyle}>Porte</TableCell>
                              <TableCell sx={tableHeaderStyle}>
                                Qtd. Máxima de Citações
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {configuracaoCompleta.configuracaoPorte.map(
                              (porte, idx) => {
                                const temListaSuja =
                                  porte.configuracaoCriterio.some(
                                    (c) => c.descricao === "Lista Suja",
                                  );

                                const listaSuja =
                                  porte.configuracaoListaSuja.find(
                                    (item, index, self) =>
                                      index ===
                                      self.findIndex(
                                        (t) => t.descricao === item.descricao,
                                      ),
                                  );

                                if (temListaSuja && listaSuja) {
                                  return (
                                    <TableRow key={`ls-${idx}`} hover>
                                      <TableCell>
                                        <Typography
                                          variant="body2"
                                          fontWeight="500"
                                        >
                                          {porte.descricao}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          value={listaSuja.quantidade}
                                          onChange={(e) =>
                                            handleListaSujaChange(
                                              idx,
                                              0,
                                              "quantidade",
                                              e.target.value,
                                            )
                                          }
                                          type="number"
                                          variant="outlined"
                                          size="small"
                                          sx={{ width: 120 }}
                                          InputProps={{
                                            className: "no-spinners",
                                          }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                                return null;
                              },
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                )}

                {/* 10. RESTRITIVOS CESTA */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <Gavel color="action" /> Limites de Restritivos
                      (Serasa/Boa Vista)
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TableContainer
                      component={Paper}
                      elevation={0}
                      sx={{ border: "1px solid #f0f0f0" }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={tableHeaderStyle}>Porte</TableCell>
                            <TableCell sx={tableHeaderStyle}>
                              Qtd. Máxima
                            </TableCell>
                            <TableCell sx={tableHeaderStyle}>
                              Valor Máximo R$
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {configuracaoCompleta.configuracaoPorte.map(
                            (porte, idx) => {
                              const restritivo =
                                porte.configuracaoRestritivo?.find(
                                  (item, index, self) =>
                                    index ===
                                    self.findIndex(
                                      (t) => t.descricao === item.descricao,
                                    ),
                                );
                              const temRest = porte.configuracaoCriterio.some(
                                (c) =>
                                  c.descricao ===
                                    "Restritivos Cesta Financeira" && c.ativo,
                              );

                              if (!restritivo || !temRest) return null;

                              return (
                                <TableRow key={`r-${idx}`} hover>
                                  <TableCell>
                                    <Typography
                                      variant="body2"
                                      fontWeight="500"
                                    >
                                      {porte.descricao}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      value={restritivo.quantidade}
                                      onChange={(e) =>
                                        handleRestritivoChange(
                                          idx,
                                          0,
                                          "quantidade",
                                          e.target.value,
                                        )
                                      }
                                      type="number"
                                      variant="outlined"
                                      size="small"
                                      sx={{ width: 120 }}
                                      InputProps={{ className: "no-spinners" }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      value={restritivo.valor}
                                      onChange={(e) =>
                                        handleRestritivoChange(
                                          idx,
                                          0,
                                          "valor",
                                          e.target.value,
                                        )
                                      }
                                      type="number"
                                      variant="outlined"
                                      size="small"
                                      sx={{ width: 150 }}
                                      InputProps={{ className: "no-spinners" }}
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            },
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>

                {/* 11. REFIN */}
                <Accordion sx={accordionStyle} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="h6"
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <Gavel color="action" /> Configuração do Refin
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TableContainer
                      component={Paper}
                      elevation={0}
                      sx={{ border: "1px solid #f0f0f0" }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={tableHeaderStyle}>Porte</TableCell>
                            <TableCell sx={tableHeaderStyle} width="200">
                              Valor Limite
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {configuracaoCompleta.configuracaoPorte.map(
                            (porte, idx) => {
                              const refin = porte.configuracaoCriterio.find(
                                (c) =>
                                  c.descricao === "RestritivosRefin" && c.ativo,
                              );
                              if (!refin) return null;
                              return (
                                <TableRow key={`refin-${idx}`} hover>
                                  <TableCell>
                                    <Typography
                                      variant="body2"
                                      fontWeight="500"
                                    >
                                      {porte.descricao}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      value={refin.indicadorEsperado ?? ""}
                                      onChange={(e) =>
                                        handleRefinChange(
                                          e,
                                          "RestritivosRefin",
                                          idx,
                                        )
                                      }
                                      type="number"
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      InputProps={{ className: "no-spinners" }}
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            },
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>

                {/* INDICADORES DA EMPRESA (DRE / BALANÇO) */}
                {isAdmin && (
                  <Accordion sx={accordionStyle} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h6"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <BarChart color="action" /> Mapeamento de Indicadores
                        (DRE/Balanço)
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={3}
                        p={2}
                        bgcolor="#f8fafc"
                        borderRadius={2}
                      >
                        <Typography variant="body2" color="text.secondary">
                          Configure as contas contábeis e de resultado,
                          definindo códigos e ordem de apresentação.
                        </Typography>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={handleAddIndicadorEmpresa}
                          startIcon={<Add />}
                          sx={{ borderRadius: 2 }}
                        >
                          Novo Indicador
                        </Button>
                      </Box>

                      <TableContainer
                        component={Paper}
                        elevation={0}
                        sx={{ border: "1px solid #f0f0f0" }}
                      >
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={tableHeaderStyle} width="10%">
                                Código
                              </TableCell>
                              <TableCell sx={tableHeaderStyle} width="35%">
                                Descrição
                              </TableCell>
                              <TableCell sx={tableHeaderStyle} width="25%">
                                Seção
                              </TableCell>
                              <TableCell sx={tableHeaderStyle} width="15%">
                                Ordem
                              </TableCell>
                              <TableCell
                                sx={tableHeaderStyle}
                                align="center"
                                width="15%"
                              >
                                Ações
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {configuracaoCompleta.configuracaoIndicadoresEmpresa &&
                            configuracaoCompleta.configuracaoIndicadoresEmpresa
                              .length > 0 ? (
                              configuracaoCompleta.configuracaoIndicadoresEmpresa
                                .sort(
                                  (a, b) =>
                                    a.ordemApresentacao - b.ordemApresentacao,
                                ) // Ordena pela ordem de apresentação
                                .map((ind) => (
                                  <TableRow key={ind.id} hover>
                                    <TableCell>
                                      <TextField
                                        value={ind.codigo}
                                        onChange={(e) =>
                                          handleChangeIndicadorEmpresa(
                                            ind.id,
                                            "codigo",
                                            e.target.value,
                                          )
                                        }
                                        type="number"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                          className: "no-spinners",
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <TextField
                                        value={ind.descricao}
                                        onChange={(e) =>
                                          handleChangeIndicadorEmpresa(
                                            ind.id,
                                            "descricao",
                                            e.target.value,
                                          )
                                        }
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <FormControl
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                      >
                                        <Select
                                          value={
                                            ind.secao ? ind.secao.trim() : ""
                                          }
                                          onChange={(e) =>
                                            handleChangeIndicadorEmpresa(
                                              ind.id,
                                              "secao",
                                              e.target.value,
                                            )
                                          }
                                          displayEmpty
                                        >
                                          <MenuItem value="" disabled>
                                            Selecione a Seção...
                                          </MenuItem>
                                          {CATALOGO_PARAMETROS.map((secao) => (
                                            <MenuItem
                                              key={secao.id}
                                              value={secao.label}
                                            >
                                              {secao.label}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell>
                                      <TextField
                                        value={ind.ordemApresentacao}
                                        onChange={(e) =>
                                          handleChangeIndicadorEmpresa(
                                            ind.id,
                                            "ordemApresentacao",
                                            e.target.value,
                                          )
                                        }
                                        type="number"
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                          className: "no-spinners",
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      <Button
                                        size="small"
                                        color="error"
                                        onClick={() =>
                                          handleRemoveIndicadorEmpresa(ind.id)
                                        }
                                      >
                                        Remover
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                ))
                            ) : (
                              <TableRow>
                                <TableCell
                                  colSpan={5}
                                  align="center"
                                  sx={{ py: 4, color: "text.secondary" }}
                                >
                                  Nenhum indicador mapeado. Clique em "Novo
                                  Indicador" para iniciar.
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                )}

                {/* 12. PROMPTS AZURE (Admin) */}
                {isAdmin && (
                  <Accordion sx={accordionStyle} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h6"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <SmartToy color="action" /> Prompts da IA (Pareceres)
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box display="flex" justifyContent="flex-end" mb={3}>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={handleAddPromptAzure}
                          startIcon={<Add />}
                          sx={{ borderRadius: 2 }}
                        >
                          Novo Prompt
                        </Button>
                      </Box>
                      {configuracaoCompleta.promptAzure?.length > 0 ? (
                        configuracaoCompleta.promptAzure.map((prompt) => (
                          <Card
                            elevation={0}
                            key={prompt.promptAzureId}
                            sx={{
                              mb: 3,
                              border: "1px solid #e2e8f0",
                              borderRadius: 3,
                              bgcolor: "#f8fafc",
                            }}
                          >
                            <CardContent>
                              <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                mb={2}
                              >
                                <Grid item xs={12} sm={4}>
                                  <TextField
                                    label="Nome do Parecer"
                                    value={prompt.nome || ""}
                                    onChange={(e) =>
                                      handlePromptAzureChange(
                                        prompt.promptAzureId,
                                        "nome",
                                        e.target.value,
                                      )
                                    }
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                  <FormControl
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                  >
                                    <InputLabel>Tipo de Análise</InputLabel>
                                    <Select
                                      label="Tipo de Análise"
                                      value={prompt.tipo ?? ""}
                                      onChange={(e) =>
                                        handlePromptAzureChange(
                                          prompt.promptAzureId,
                                          "tipo",
                                          Number(e.target.value),
                                        )
                                      }
                                    >
                                      <MenuItem value={0}>
                                        Parecer Completo (0)
                                      </MenuItem>
                                      <MenuItem value={1}>
                                        Parecer Empresa (1)
                                      </MenuItem>
                                      <MenuItem value={2}>
                                        Parecer Resumido (2)
                                      </MenuItem>
                                      <MenuItem value={3}>
                                        Parecer Pré-análise (3)
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  display="flex"
                                  justifyContent="flex-end"
                                >
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={prompt.ativo}
                                        onChange={(e) =>
                                          handlePromptAzureChange(
                                            prompt.promptAzureId,
                                            "ativo",
                                            e.target.checked,
                                          )
                                        }
                                        color="primary"
                                      />
                                    }
                                    label="Ativo"
                                    labelPlacement="start"
                                  />
                                </Grid>
                              </Grid>
                              <TextField
                                label="Instrução (Prompt)"
                                value={prompt.promptTexto || ""}
                                onChange={(e) =>
                                  handlePromptAzureChange(
                                    prompt.promptAzureId,
                                    "promptTexto",
                                    e.target.value,
                                  )
                                }
                                fullWidth
                                multiline
                                rows={6}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                sx={{ bgcolor: "white" }}
                              />
                            </CardContent>
                          </Card>
                        ))
                      ) : (
                        <Typography
                          align="center"
                          color="text.secondary"
                          py={4}
                        >
                          Nenhuma configuração de prompt. Clique em "Novo
                          Prompt" para começar.
                        </Typography>
                      )}
                    </AccordionDetails>
                  </Accordion>
                )}

                {/* 13. EXTRATORES (Admin) */}
                {isAdmin && (
                  <Accordion sx={accordionStyle} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h6"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <SmartToy color="action" /> Extratores de Dados (IA
                        Vision)
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box display="flex" justifyContent="flex-end" mb={3}>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={handleAddExtrator}
                          startIcon={<Add />}
                          sx={{ borderRadius: 2 }}
                        >
                          Novo Extrator
                        </Button>
                      </Box>
                      {configuracaoCompleta.configuracaoExtrator?.length > 0 ? (
                        configuracaoCompleta.configuracaoExtrator.map(
                          (extrator) => (
                            <Card
                              elevation={0}
                              key={extrator.configuracaoExtratorId}
                              sx={{
                                mb: 4,
                                border: "1px solid #e2e8f0",
                                borderRadius: 3,
                              }}
                            >
                              <CardContent
                                sx={{
                                  bgcolor: "#f8fafc",
                                  borderBottom: "1px solid #e2e8f0",
                                }}
                              >
                                <Grid container spacing={2} alignItems="center">
                                  <Grid item xs={12} sm={3}>
                                    <FormControl
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                    >
                                      <InputLabel>Tipo de Documento</InputLabel>
                                      <Select
                                        label="Tipo de Documento"
                                        value={extrator.tipoDocumento}
                                        onChange={(e) =>
                                          handleExtratorChange(
                                            extrator.configuracaoExtratorId,
                                            "tipoDocumento",
                                            e.target.value,
                                          )
                                        }
                                        sx={{ bgcolor: "white" }}
                                      >
                                        <MenuItem value={1}>
                                          Balanço / DRE
                                        </MenuItem>
                                        <MenuItem value={2}>
                                          Declaração Faturamento
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs={12} sm={3}>
                                    <TextField
                                      label="Nome do Extrator"
                                      value={extrator.nomeAtributo || ""}
                                      onChange={(e) =>
                                        handleExtratorChange(
                                          extrator.configuracaoExtratorId,
                                          "nomeAtributo",
                                          e.target.value,
                                        )
                                      }
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      sx={{ bgcolor: "white" }}
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={3}>
                                    <FormControl
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                    >
                                      <InputLabel>Tipo Retorno</InputLabel>
                                      <Select
                                        label="Tipo Retorno"
                                        value={extrator.tipoRetorno}
                                        onChange={(e) =>
                                          handleExtratorChange(
                                            extrator.configuracaoExtratorId,
                                            "tipoRetorno",
                                            e.target.value,
                                          )
                                        }
                                        sx={{ bgcolor: "white" }}
                                      >
                                        <MenuItem value={1}>Lista</MenuItem>
                                        <MenuItem value={2}>Objeto</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={3}
                                    display="flex"
                                    justifyContent="flex-end"
                                  >
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          checked={extrator.ativo}
                                          onChange={(e) =>
                                            handleExtratorStatusChange(
                                              extrator.configuracaoExtratorId,
                                              e.target.checked,
                                            )
                                          }
                                          color="primary"
                                        />
                                      }
                                      label="Ativo"
                                      labelPlacement="start"
                                    />
                                  </Grid>
                                  <Grid item xs={12}>
                                    <TextField
                                      label="Prompt / Instrução Base"
                                      value={extrator.prompt || ""}
                                      onChange={(e) =>
                                        handleExtratorChange(
                                          extrator.configuracaoExtratorId,
                                          "prompt",
                                          e.target.value,
                                        )
                                      }
                                      fullWidth
                                      multiline
                                      rows={2}
                                      variant="outlined"
                                      size="small"
                                      InputLabelProps={{ shrink: true }}
                                      sx={{ bgcolor: "white" }}
                                    />
                                  </Grid>
                                </Grid>
                              </CardContent>

                              <Box p={2}>
                                <Stack
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  mb={2}
                                >
                                  <Typography variant="subtitle1">
                                    Parâmetros Esperados
                                  </Typography>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() =>
                                      handleOpenModalParametro(
                                        extrator.configuracaoExtratorId,
                                      )
                                    }
                                    startIcon={<Add />}
                                  >
                                    Adicionar Campo
                                  </Button>
                                </Stack>

                                {extrator.configuracaoExtratorParametro
                                  ?.length > 0 ? (
                                  extrator.configuracaoExtratorParametro.map(
                                    (param) => (
                                      <Box
                                        key={
                                          param.configuracaoExtratorParametroId
                                        }
                                        sx={{
                                          mb: 2,
                                          p: 2,
                                          border: "1px solid #e0e0e0",
                                          borderRadius: 2,
                                          bgcolor: "#fafbfc",
                                        }}
                                      >
                                        <Grid
                                          container
                                          spacing={2}
                                          alignItems="center"
                                        >
                                          <Grid item xs={12} sm={3}>
                                            <TextField
                                              label="Chave Extrator"
                                              value={param.nomeAtributo}
                                              disabled
                                              fullWidth
                                              variant="outlined"
                                              size="small"
                                              sx={{ bgcolor: "white" }}
                                            />
                                          </Grid>
                                          <Grid item xs={12} sm={3}>
                                            <FormControl
                                              variant="outlined"
                                              fullWidth
                                              size="small"
                                              disabled
                                              sx={{ bgcolor: "white" }}
                                            >
                                              <InputLabel>Catálogo</InputLabel>
                                              <Select
                                                value={String(
                                                  param.tipoParametro || "",
                                                )}
                                                label="Catálogo"
                                              >
                                                {CATALOGO_PARAMETROS.map(
                                                  (op) => (
                                                    <MenuItem
                                                      key={op.id}
                                                      value={String(op.id)}
                                                    >
                                                      {op.label}
                                                    </MenuItem>
                                                  ),
                                                )}
                                              </Select>
                                            </FormControl>
                                          </Grid>
                                          <Grid item xs={12} sm={3}>
                                            <FormControl
                                              variant="outlined"
                                              fullWidth
                                              size="small"
                                              disabled
                                              sx={{ bgcolor: "white" }}
                                            >
                                              <InputLabel>Formato</InputLabel>
                                              <Select
                                                value={param.tipoAtributo || 0}
                                                label="Formato"
                                              >
                                                <MenuItem value={1}>
                                                  Decimal
                                                </MenuItem>
                                                <MenuItem value={2}>
                                                  String
                                                </MenuItem>
                                              </Select>
                                            </FormControl>
                                          </Grid>
                                          <Grid item xs={4} sm={1}>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={param.obrigatorio}
                                                  onChange={(e) =>
                                                    handleExtratorParametroChange(
                                                      extrator.configuracaoExtratorId,
                                                      param.configuracaoExtratorParametroId,
                                                      "obrigatorio",
                                                      e.target.checked,
                                                    )
                                                  }
                                                  size="small"
                                                />
                                              }
                                              label={
                                                <Typography variant="caption">
                                                  Obrig.
                                                </Typography>
                                              }
                                            />
                                          </Grid>
                                          <Grid item xs={4} sm={1}>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={param.chave}
                                                  onChange={(e) =>
                                                    handleExtratorParametroChange(
                                                      extrator.configuracaoExtratorId,
                                                      param.configuracaoExtratorParametroId,
                                                      "chave",
                                                      e.target.checked,
                                                    )
                                                  }
                                                  size="small"
                                                  color="secondary"
                                                />
                                              }
                                              label={
                                                <Typography variant="caption">
                                                  Chave
                                                </Typography>
                                              }
                                            />
                                          </Grid>
                                          <Grid item xs={4} sm={1}>
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={param.ativo}
                                                  onChange={(e) =>
                                                    handleExtratorParametroChange(
                                                      extrator.configuracaoExtratorId,
                                                      param.configuracaoExtratorParametroId,
                                                      "ativo",
                                                      e.target.checked,
                                                    )
                                                  }
                                                  size="small"
                                                  color="primary"
                                                />
                                              }
                                              label={
                                                <Typography variant="caption">
                                                  Ativo
                                                </Typography>
                                              }
                                            />
                                          </Grid>
                                          <Grid item xs={12}>
                                            <TextField
                                              label="Instrução do campo (Prompt)"
                                              value={
                                                param.definicaoAtributo || ""
                                              }
                                              onChange={(e) =>
                                                handleExtratorParametroChange(
                                                  extrator.configuracaoExtratorId,
                                                  param.configuracaoExtratorParametroId,
                                                  "definicaoAtributo",
                                                  e.target.value,
                                                )
                                              }
                                              fullWidth
                                              multiline
                                              rows={5}
                                              variant="outlined"
                                              size="small"
                                              InputLabelProps={{ shrink: true }}
                                              sx={{ bgcolor: "white" }}
                                            />
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    ),
                                  )
                                ) : (
                                  <Typography
                                    align="center"
                                    color="text.secondary"
                                    py={2}
                                    variant="body2"
                                  >
                                    Nenhum parâmetro mapeado.
                                  </Typography>
                                )}
                              </Box>
                            </Card>
                          ),
                        )
                      ) : (
                        <Typography
                          align="center"
                          color="text.secondary"
                          py={4}
                        >
                          Nenhum extrator configurado.
                        </Typography>
                      )}
                    </AccordionDetails>
                  </Accordion>
                )}

                {/* 14. GARANTIAS */}
                {isEmpresaRdp && (
                  <Accordion sx={accordionStyle} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h6"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <Security color="action" /> Garantias (RDP)
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ mb: 3 }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          paragraph
                        >
                          Cadastre cada combinação de garantias aceitas e defina
                          o fator aplicado no cálculo.
                        </Typography>
                        <Stack direction="row" spacing={2} mb={2}>
                          <Button
                            variant="outlined"
                            onClick={handleAddGarantiaComposicao}
                            startIcon={<Add />}
                            sx={{ borderRadius: 2 }}
                          >
                            Adicionar composição manual
                          </Button>
                          <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleCarregarComposicoesPadraoRdp}
                            sx={{ borderRadius: 2 }}
                          >
                            Carregar padrões RDP
                          </Button>
                        </Stack>
                        {errosGarantias.length > 0 && (
                          <Alert severity="error" sx={{ mb: 2 }}>
                            {errosGarantias.map((msg, i) => (
                              <Box key={i}>• {msg}</Box>
                            ))}
                          </Alert>
                        )}
                        <TableContainer
                          component={Paper}
                          elevation={0}
                          sx={{ border: "1px solid #f0f0f0" }}
                        >
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell sx={tableHeaderStyle} width="35%">
                                  Tipos de Garantia
                                </TableCell>
                                <TableCell sx={tableHeaderStyle} width="15%">
                                  Fator (0 a 1)
                                </TableCell>
                                <TableCell sx={tableHeaderStyle} width="30%">
                                  Descrição
                                </TableCell>
                                <TableCell sx={tableHeaderStyle} align="center">
                                  Ativo
                                </TableCell>
                                <TableCell sx={tableHeaderStyle} align="center">
                                  Ações
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(
                                configuracaoCompleta.configuracaoGarantiaComposicao ||
                                []
                              ).map((comp) => (
                                <TableRow key={rowKeyGarantia(comp)} hover>
                                  <TableCell>
                                    <Autocomplete
                                      multiple
                                      disableCloseOnSelect
                                      size="small"
                                      options={TIPOS_GARANTIA_RDP.map(
                                        (o) => o.codigo,
                                      )}
                                      groupBy={(codigo) =>
                                        getGrupoTipoGarantia(codigo)
                                      }
                                      getOptionLabel={(cod) =>
                                        getLabelTipoGarantia(cod)
                                      }
                                      value={parseChaveCombinacaoGarantia(
                                        comp.chaveCombinacao,
                                      )}
                                      onChange={(_, val) =>
                                        handleGarantiaComposicaoChange(
                                          rowKeyGarantia(comp),
                                          "tipos",
                                          val,
                                        )
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          placeholder="Selecione..."
                                        />
                                      )}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      value={comp.fator}
                                      onChange={(e) =>
                                        handleGarantiaComposicaoChange(
                                          rowKeyGarantia(comp),
                                          "fator",
                                          Number(e.target.value),
                                        )
                                      }
                                      type="number"
                                      inputProps={{
                                        min: 0,
                                        max: 1,
                                        step: 0.01,
                                      }}
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      value={comp.descricao || ""}
                                      onChange={(e) =>
                                        handleGarantiaComposicaoChange(
                                          rowKeyGarantia(comp),
                                          "descricao",
                                          e.target.value,
                                        )
                                      }
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <Switch
                                      checked={comp.ativo}
                                      onChange={(e) =>
                                        handleGarantiaComposicaoChange(
                                          rowKeyGarantia(comp),
                                          "ativo",
                                          e.target.checked,
                                        )
                                      }
                                      color="primary"
                                      size="small"
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <Button
                                      size="small"
                                      color="error"
                                      onClick={() =>
                                        handleRemoveGarantiaComposicao(
                                          rowKeyGarantia(comp),
                                        )
                                      }
                                    >
                                      Remover
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                              {(!configuracaoCompleta.configuracaoGarantiaComposicao ||
                                configuracaoCompleta
                                  .configuracaoGarantiaComposicao.length ===
                                  0) && (
                                <TableRow>
                                  <TableCell
                                    colSpan={5}
                                    align="center"
                                    sx={{ py: 4, color: "text.secondary" }}
                                  >
                                    Nenhuma garantia cadastrada.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}

                {/* 15. EMAILS BRT */}
                {isEmpresaBrt && (
                  <Accordion sx={accordionStyle} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h6"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <Email color="action" /> Disparos de E-mail (BRT)
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  configuracaoCompleta.configuracaoEmailBrt
                                    ?.ativo || false
                                }
                                onChange={(e) => {
                                  const { checked } = e.target;
                                  setConfiguracaoCompleta((prev) => {
                                    const c = { ...prev };
                                    if (!c.configuracaoEmailBrt) {
                                      c.configuracaoEmailBrt = {
                                        configuracaoEmailBrtId:
                                          generateTempId(),
                                        configuracaoId: c.configuracaoId,
                                        ativo: checked,
                                        destinatarios: "",
                                        assunto: "",
                                        copia: "",
                                        dataInclusao: "",
                                        usuarioInclusao: "",
                                        dataEdicao: "",
                                        usuarioEdicao: "",
                                      };
                                    } else {
                                      c.configuracaoEmailBrt.ativo = checked;
                                    }
                                    return c;
                                  });
                                }}
                              />
                            }
                            label="Habilitar envio de alertas por e-mail"
                          />
                        </Grid>
                        {configuracaoCompleta.configuracaoEmailBrt && (
                          <>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Destinatários"
                                placeholder="email1@ex.com, email2@ex.com"
                                value={
                                  configuracaoCompleta.configuracaoEmailBrt
                                    .destinatarios || ""
                                }
                                onChange={(e) =>
                                  setConfiguracaoCompleta((p) => ({
                                    ...p,
                                    configuracaoEmailBrt: {
                                      ...p.configuracaoEmailBrt!,
                                      destinatarios: e.target.value,
                                    },
                                  }))
                                }
                                fullWidth
                                multiline
                                rows={2}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Com Cópia (CC)"
                                placeholder="email1@ex.com"
                                value={
                                  configuracaoCompleta.configuracaoEmailBrt
                                    .copia || ""
                                }
                                onChange={(e) =>
                                  setConfiguracaoCompleta((p) => ({
                                    ...p,
                                    configuracaoEmailBrt: {
                                      ...p.configuracaoEmailBrt!,
                                      copia: e.target.value,
                                    },
                                  }))
                                }
                                fullWidth
                                multiline
                                rows={2}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                label="Assunto Base"
                                value={
                                  configuracaoCompleta.configuracaoEmailBrt
                                    .assunto || ""
                                }
                                onChange={(e) =>
                                  setConfiguracaoCompleta((p) => ({
                                    ...p,
                                    configuracaoEmailBrt: {
                                      ...p.configuracaoEmailBrt!,
                                      assunto: e.target.value,
                                    },
                                  }))
                                }
                                fullWidth
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
              </Box>
            ) : (
              isAdmin && (
                <Box mt={10} textAlign="center">
                  <Business
                    sx={{ fontSize: 64, color: "text.disabled", mb: 2 }}
                  />
                  <Typography variant="h5" color="text.secondary">
                    Selecione uma Empresa
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Utilize o campo superior para carregar ou criar a
                    parametrização de uma empresa.
                  </Typography>
                </Box>
              )
            )}
          </Content>
        </Container>
      </Box>

      {/* STICKY FOOTER PARA SALVAR / CANCELAR */}
      {configuracaoCompleta.empresa &&
        configuracaoCompleta.empresa.empresaId && (
          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              bgcolor: "rgba(255, 255, 255, 0.9)",
              backdropFilter: "blur(10px)",
              borderTop: "1px solid #e2e8f0",
              boxShadow: "0 -10px 40px rgba(0,0,0,0.05)",
              py: 2,
              px: { xs: 2, md: 5 },
              zIndex: 1000,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={cancelarAlteracoes}
              disabled={
                erroIntervalo.erro ||
                !validarSomaTotal() ||
                !validarSomaAnaliseSimplificada()
              }
              startIcon={<Close />}
              sx={{ borderRadius: 2 }}
            >
              Cancelar Alterações
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={salvarConfiguracoes}
              disabled={
                erroIntervalo.erro ||
                !validarSomaTotal() ||
                !validarSomaAnaliseSimplificada()
              }
              startIcon={<Save />}
              sx={{
                borderRadius: 2,
                px: 4,
                boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
              }}
            >
              Salvar Configurações
            </Button>
          </Box>
        )}

      {/* MODAL ADICIONAR PARÂMETRO (Mantido Intacto) */}
      <Dialog
        open={modalParametroOpen}
        onClose={handleCloseModalParametro}
        maxWidth="md"
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogContent>
          <ModalAdicionarParametro
            listaAtual={getParametrosAtuaisDoExtratorAlvo() as any}
            onSalvar={handleSalvarParametroDoModal}
            onCancelar={handleCloseModalParametro}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
